import Vue from 'vue';
import { MESSAGE_TYPE, MESSAGE_STATUS } from "../api/enums.js"
import userStore from './userStore';
import localForage from 'localforage';
import vscodeStorageAdapter from './vscodeStorageAdapter.js';
import http from '../api/httpRequest.js';
import { createAgentTaskStatusContent, parseAgentTaskStatus, updateTaskStatus } from '../api/messageStructures.js';

/* 为了加速拉取离线消息效率，拉取时消息暂时存储到cacheChats,等
待所有离线消息拉取完成后，再统一放至vuex中进行渲染*/
let cacheChats = [];

// 保存防抖计时器（放在模块级别）
let saveTimer = null;

export default {
	state: {
		activeChat: null,
		privateMsgMaxId: 0,
		groupMsgMaxId: 0,
		loadingPrivateMsg: false,
		loadingGroupMsg: false,
		chats: [],
		// 防重复加载状态
		isLoadingChat: false,
		// 智能体会话状态管理
		agentSessionStatuses: {}, // { happySessionId: statusData }
		happySessionMappings: {},  // { imChatId: happySessionId }
		// 多选模式状态
		multiSelectMode: {
			active: false,           // 是否处于多选模式
			selectedMessages: [],    // 已选中的消息ID数组
			chatId: null            // 当前多选模式所在的会话ID
		},
		// 🔥 消息引用状态
		quotedMessages: {
			active: false,           // 是否有待发送的引用
			messages: [],            // 引用的消息列表
			chatId: null            // 当前引用所在的会话ID
		},
		// 🔥 智能体任务状态追踪
		agentTaskStatuses: {
			// { taskId: { messageId, chatId, sessionId, status, lastUpdate } }
		},
		// 🔥 sessionId 到 taskId 的映射（用于 WebSocket 消息定位）
		agentTaskSessionMappings: {
			// { sessionId: taskId }
		}
	},

	mutations: {
		initChats(state, chatsData) {
			if (chatsData && chatsData.chats) {
		// 🔥 初始化智能体任务状态存储
		if (!state.agentTaskStatuses) {
			state.agentTaskStatuses = {};
		} else {
			state.agentTaskStatuses = {};
		}
		if (!state.agentTaskSessionMappings) {
			state.agentTaskSessionMappings = {};
		} else {
			state.agentTaskSessionMappings = {};
		}
				// 基本的聊天数据清理
				const cleanedChats = chatsData.chats.filter(chat => {
					if (!chat || !Array.isArray(chat.messages)) {
						if (chat) {
							chat.messages = [];
						}
						return chat !== null && chat !== undefined;
					}

					// 🔧 防止图片一直处在加载中状态
					chat.messages.forEach(msg => {
						if (msg && msg.loadStatus === "loading") {
							msg.loadStatus = "fail";
						}
					});

					return true;
				});
				
				// 🔧 修复数据：处理showName为undefined的会话（特别是自己给自己的会话）
				const currentUser = userStore.state.userInfo;
				let fixedCount = 0;

				cleanedChats.forEach(chat => {
					if (chat && chat.type === 'PRIVATE' && !chat.showName) {
						console.log(`[ChatStore] 🔧 发现无效会话，targetId: ${chat.targetId}，开始修复...`);

						// 如果是当前用户自己
						if (currentUser && currentUser.id == chat.targetId) {
							chat.showName = currentUser.nickName || "我";
							chat.headImage = currentUser.headImageThumb || currentUser.headImage || "";
							chat.stored = false; // 标记需要重新保存
							fixedCount++;
							console.log(`[ChatStore] ✅ 修复自己的会话，showName: ${chat.showName}`);
						} else {
							// 其他用户的会话（虽然可能性较小，但也修复一下）
							chat.showName = "未知用户";
							chat.stored = false;
							fixedCount++;
							console.log(`[ChatStore] ✅ 修复未知用户会话，targetId: ${chat.targetId}`);
						}
					}
				});
				
				// 🔥 修复智能体会话的 showName（必须在设置 state.chats 之前）
				cleanedChats.forEach(chat => {
					if (chat && chat.type === 'AGENT') {
						// 从 targetId 解析父会话信息
						const parts = chat.targetId.split('_agent_');
						if (parts.length === 2) {
							const prefix = parts[0];
							const agentIdFromTargetId = parts[1]; // 从 targetId 提取智能体 ID
							let parentType, parentId;

							if (prefix.startsWith('PRIVATE_')) {
								parentType = 'PRIVATE';
								parentId = prefix.substring('PRIVATE_'.length);
							} else if (prefix.startsWith('GROUP_')) {
								parentType = 'GROUP';
								parentId = prefix.substring('GROUP_'.length);
							}

							// 从 cleanedChats 查找父会话
							const parentChat = cleanedChats.find(c =>
								c.type === parentType && String(c.targetId) === String(parentId)
							);

							// 🔥 提取纯净的智能体名称（去除所有可能的层级分隔符）
							let agentName = chat.agentName;

							// 1. 如果 agentName 存在但包含分隔符，只保留最后一部分
							if (agentName) {
								// 处理 Unicode 箭头 › 和普通箭头 >
								if (agentName.includes(' › ')) {
									agentName = agentName.split(' › ').pop().trim();
									console.log(`[ChatStore] 🔧 清理 agentName (›): "${chat.agentName}" -> "${agentName}"`);
								} else if (agentName.includes(' > ')) {
									agentName = agentName.split(' > ').pop().trim();
									console.log(`[ChatStore] 🔧 清理 agentName (>): "${chat.agentName}" -> "${agentName}"`);
								}
							}

							// 2. 如果 agentName 为空，从 showName 提取
							if (!agentName && chat.showName) {
								// 格式：会话名 › 智能体名 或 会话名 > 智能体名
								if (chat.showName.includes(' › ')) {
									agentName = chat.showName.split(' › ').pop().trim();
								} else if (chat.showName.includes(' > ')) {
									agentName = chat.showName.split(' > ').pop().trim();
								} else {
									// showName 本身可能就是智能体名
									agentName = chat.showName;
								}
								console.log(`[ChatStore] 🔧 从 showName 提取 agentName: "${agentName}"`);
							}

							// 3. 如果找到父会话和智能体名称，修复 showName
							if (parentChat && parentChat.showName && agentName) {
								const correctShowName = `${parentChat.showName} › ${agentName}`;
								if (chat.showName !== correctShowName) {
									console.log(`[ChatStore] 🔥 修复智能体会话 showName: "${chat.showName}" -> "${correctShowName}"`);
									chat.showName = correctShowName;
									chat.stored = false;
									fixedCount++;
								}

								// 🔥 同时更新 agentName 字段为纯净的智能体名
								if (chat.agentName !== agentName) {
									chat.agentName = agentName;
									console.log(`[ChatStore] 🔥 更新 agentName: "${agentName}"`);
								}
							} else {
								// 如果找不到父会话，记录警告
								if (!parentChat) {
									console.warn(`[ChatStore] ⚠️ 智能体会话找不到父会话: ${chat.targetId}, parentType=${parentType}, parentId=${parentId}`);
								}
								if (!agentName) {
									console.warn(`[ChatStore] ⚠️ 智能体会话无法提取智能体名称: ${chat.targetId}`);
								}
							}

							// 4. 确保 parentId 和 parentType 字段正确设置
							if (!chat.parentId || !chat.parentType) {
								chat.parentId = parentId;
								chat.parentType = parentType;
								chat.stored = false;
								console.log(`[ChatStore] 🔧 设置智能体会话的父级信息: parentType=${parentType}, parentId=${parentId}`);
							}
						}
					}
				});

				if (fixedCount > 0) {
					console.log(`[ChatStore] 🔧 数据修复完成，修复了 ${fixedCount} 个无效会话`);
				}
				state.chats = cleanedChats;

				// 从历史消息重建智能体任务状态索引
				const taskStatusMap = new Map();

				state.chats.forEach(chat => {
					if (chat.messages && Array.isArray(chat.messages)) {
						chat.messages.forEach(msg => {
							// 处理 type=60/61/62 消息
							if ((msg.type === 60 || msg.type === 61 || msg.type === 62) && msg.content) {
								try {
									const contentParsed = typeof msg.content === 'string'
										? JSON.parse(msg.content)
										: msg.content;

									const taskId = contentParsed.taskId;
									if (!taskId) return;

									// 推断状态
									let status = 'running';
									if (msg.type === 61) status = 'completed';
									else if (msg.type === 62) status = 'error';

									// 获取或创建任务记录
									if (!taskStatusMap.has(taskId)) {
										taskStatusMap.set(taskId, {
											taskId,
											sessionId: contentParsed.sessionId,
											agentId: contentParsed.agentId || 'unknown',
											agentName: contentParsed.agentName || '智能体',
											userId: contentParsed.userId || msg.sendId, // 任务发起者ID
											statusHistory: [],
											chatId: chat.targetId
										});
									}

									const taskData = taskStatusMap.get(taskId);
									
									// 更新 userId（如果之前没有）
									if (!taskData.userId && (contentParsed.userId || msg.sendId)) {
										taskData.userId = contentParsed.userId || msg.sendId;
									}
									
									// 添加状态到历史
									taskData.statusHistory.push({
										status,
										message: contentParsed.message || '状态更新',
										timestamp: msg.sendTime || Date.now(),
										collapsed: false
									});
									
									// 更新最新状态
									taskData.status = status;
									taskData.message = contentParsed.message || '';
									taskData.progress = contentParsed.progress || 0;
									taskData.result = contentParsed.result;
									taskData.lastUpdate = msg.sendTime || Date.now();

								} catch (e) {
									console.error('[ChatStore] 解析状态消息失败:', e);
								}
							}
						});
					}
				});

				// 将所有旧状态设置为 collapsed: true，只保留最新的为 false
				taskStatusMap.forEach((taskData, taskId) => {
					if (taskData.statusHistory.length > 0) {
						taskData.statusHistory.forEach((item, index) => {
							item.collapsed = index < taskData.statusHistory.length - 1;
						});
						
						// 写入 agentTaskStatuses
						Vue.set(state.agentTaskStatuses, taskId, {
							type: 'AGENT_TASK_STATUS',
							version: '1.0',
							...taskData
						});

						// 建立 sessionId 映射
						if (taskData.sessionId) {
							Vue.set(state.agentTaskSessionMappings, taskData.sessionId, taskId);
						}
					}
				});

				console.log('[ChatStore] 状态索引重建完成，共', taskStatusMap.size, '个任务');

				// 从存储的数据中恢复最大ID（如果有）
				if (chatsData.privateMsgMaxId) {
					state.privateMsgMaxId = chatsData.privateMsgMaxId;
				}
				if (chatsData.groupMsgMaxId) {
					state.groupMsgMaxId = chatsData.groupMsgMaxId;
				}
				
				// 重新计算实际的最大消息ID（基于当前的消息）
				let actualPrivateMaxId = 0;
				let actualGroupMaxId = 0;
				
				cleanedChats.forEach(chat => {
					if (chat.messages && chat.messages.length > 0) {
						chat.messages.forEach(msg => {
							if (msg && msg.id) {
								const msgId = typeof msg.id === 'string' ? parseInt(msg.id) : msg.id;
								if (!isNaN(msgId)) {
									if (chat.type === 'PRIVATE' && msgId > actualPrivateMaxId) {
										actualPrivateMaxId = msgId;
									} else if (chat.type === 'GROUP' && msgId > actualGroupMaxId) {
										actualGroupMaxId = msgId;
									}
								}
							}
						});
					}
				});
				
				// 如果计算出的实际最大ID大于存储的值，更新它
				if (actualPrivateMaxId > state.privateMsgMaxId) {
					console.log(`[ChatStore] 更新privateMsgMaxId: ${state.privateMsgMaxId} -> ${actualPrivateMaxId}`);
					state.privateMsgMaxId = actualPrivateMaxId;
				}
				if (actualGroupMaxId > state.groupMsgMaxId) {
					console.log(`[ChatStore] 更新groupMsgMaxId: ${state.groupMsgMaxId} -> ${actualGroupMaxId}`);
					state.groupMsgMaxId = actualGroupMaxId;
				}

				// 🔧 如果修复了数据，自动保存到存储
				if (fixedCount > 0) {
					this.commit("saveToStorage");
				}

			console.log(`[ChatStore] ✅ 聊天数据初始化完成，有效聊天数量: ${state.chats.length}`);

			// 🔍 调试日志：恢复的智能体任务统计
			const restoredTasksCount = Object.keys(state.agentTaskStatuses).length;
			const restoredSessionMappingsCount = Object.keys(state.agentTaskSessionMappings).length;
			console.log('[DEBUG-PERSIST] initChats 完成 - 智能体任务恢复统计:', {
				restoredTasksCount,
				restoredSessionMappingsCount,
				taskIds: Object.keys(state.agentTaskStatuses),
				sessionMappings: state.agentTaskSessionMappings
			});
		} else {
				console.log('[ChatStore] 📭 无聊天数据需要初始化');
			}
		},
		openChat(state, chatInfo) {
			
			let chats = this.getters.findChats()
			let chat = null;
			
			// 🔧 增强调试：检查现有会话
			console.log(`🔧 [openChat] 检查现有${chats.length}个会话...`,chats);
			
			for (let idx in chats) {
				const existingChat = chats[idx];
				const isSame = this.getters.isSameChat(existingChat, chatInfo);
				
				// 🔧 优化：只在找到匹配时输出终端会话日志
				if ((chatInfo.isTerminalChat || existingChat.isTerminalChat) && isSame) {
					console.log(`🔧 [openChat] 终端会话匹配 [${idx}]: ${existingChat.showName} (${existingChat.targetId})`);
				}
				
				if (isSame) {
					chat = existingChat;
					console.log(`✅ [openChat] 找到现有会话，移到顶部: ${chat.showName}`);
					// 放置头部
					this.commit("moveTop", idx)
					break;
				}
			}
			
			// 🔥 切换会话时，清空不属于当前会话的引用消息
			if (state.quotedMessages.active && state.quotedMessages.chatId !== chatInfo.targetId) {
				console.log(`🔧 [openChat] 切换会话，清空引用消息 (${state.quotedMessages.chatId} -> ${chatInfo.targetId})`);
				this.commit('clearQuotedMessages');
			}
			
			// 创建会话
			if (chat == null) {
				console.log(`➕ [openChat] 创建新会话: ${chatInfo.showName || chatInfo.targetId}`);
				chat = {
					targetId: chatInfo.targetId,
					type: chatInfo.type,
					showName: chatInfo.showName,
					headImage: chatInfo.headImage,
					lastContent: "",
					lastSendTime: new Date().getTime(),
					unreadCount: 0,
					messages: [],
					atMe: false,
					atAll: false,
					stored: false,
					delete: false,
					// 🔧 修正：终端会话标识（目标终端模式）
					senderTerminal: chatInfo.senderTerminal,
					targetTerminal: chatInfo.targetTerminal,
					isTerminalChat: chatInfo.isTerminalChat || false,
					// 🔧 兼容性：保留旧字段以防其他代码使用
					receivingTerminal: chatInfo.receivingTerminal,
					isTerminalInbox: chatInfo.isTerminalInbox || false,
					// 🔧 保留lastTimeTip，避免插入不必要的时间提示
					lastTimeTip: chatInfo.lastTimeTip || null
				};
				chats.unshift(chat);
				
				console.log(`✅ [openChat] 新会话已创建，当前会话总数: ${chats.length}`);
			}
		},
		activeChat(state, idx) {
			console.log(state)
			let chats = this.getters.findChats();
			const newChat = chats[idx];
			
			// 🔥 切换会话时，清空不属于当前会话的引用消息
			if (newChat && state.quotedMessages.active && state.quotedMessages.chatId !== newChat.targetId) {
				console.log(`🔧 [activeChat] 切换会话，清空引用消息 (${state.quotedMessages.chatId} -> ${newChat.targetId})`);
				this.commit('clearQuotedMessages');
			}
			
			state.activeChat = newChat;
		},
		clearActiveChat(state) {
			state.activeChat = null;
		},
		resetUnreadCount(state, chatInfo) {
			let chats = this.getters.findChats();
			for (let idx in chats) {
				if (chats[idx].type == chatInfo.type &&
					chats[idx].targetId == chatInfo.targetId) {
					chats[idx].unreadCount = 0;
					chats[idx].atMe = false;
					chats[idx].atAll = false;
					chats[idx].stored = false;
					this.commit("saveToStorage");
					break;
				}
			}
		},
		readedMessage(state, pos) {
			let chat = this.getters.findChatByFriend(pos.friendId);
			if (!chat) return;
			chat.messages.forEach((m) => {
				if (m.id && m.selfSend && m.status < MESSAGE_STATUS.RECALL) {
					// pos.maxId为空表示整个会话已读
					if (!pos.maxId || m.id <= pos.maxId) {
						m.status = MESSAGE_STATUS.READED
						chat.stored = false;
					}
				}
			})
			this.commit("saveToStorage");
		},
		removeChat(state, idx) {
			let chats = this.getters.findChats();
			const chatToRemove = chats[idx];

			if (!chatToRemove) {
				console.error('[ChatStore] 删除失败：索引无效', idx);
				return;
			}

			if (chatToRemove == state.activeChat) {
				state.activeChat = null;
			}

			// 真正删除会话，而不是只标记delete
			console.log('[ChatStore] 删除会话，索引:', idx, '类型:', chatToRemove.type, 'targetId:', chatToRemove.targetId, 'skipGeneralStorage:', chatToRemove.skipGeneralStorage);

			// 删除持久化数据
			const userInfo = userStore.state.userInfo;
			if (userInfo && userInfo.id) {
				const userId = userInfo.id;
				const key = `chats-${userId}`;

				// 智能体会话使用独立存储，key就是targetId
				if (chatToRemove.skipGeneralStorage || chatToRemove.type === 'AGENT') {
					const agentChatKey = chatToRemove.targetId;
					console.log('[ChatStore] 删除智能体会话持久化数据:', agentChatKey);

					// 删除智能体会话数据
					localForage.removeItem(agentChatKey).then(() => {
						console.log('[ChatStore] 智能体会话持久化数据删除成功:', agentChatKey);
					}).catch(err => {
						console.error('[ChatStore] 删除智能体会话持久化数据失败:', err);
					});

					// 从 chatKeys 数组中移除
					localForage.getItem(key).then(existingData => {
						if (existingData && existingData.chatKeys) {
							const oldLength = existingData.chatKeys.length;
							existingData.chatKeys = existingData.chatKeys.filter(k => k !== agentChatKey);
							console.log('[ChatStore] 从chatKeys中移除智能体会话key:', agentChatKey, '原长度:', oldLength, '新长度:', existingData.chatKeys.length);

							// 更新 chatKeys
							localForage.setItem(key, existingData).then(() => {
								console.log('[ChatStore] chatKeys更新成功');
							});
						}
					});
				} else {
					// 普通会话
					const chatKey = `${key}-${chatToRemove.type}-${chatToRemove.targetId}`;
					console.log('[ChatStore] 删除普通会话持久化数据:', chatKey);

					// 立即删除 localStorage 中的会话数据
					localForage.removeItem(chatKey).then(() => {
						console.log('[ChatStore] 持久化数据删除成功:', chatKey);
					}).catch(err => {
						console.error('[ChatStore] 删除持久化数据失败:', err);
					});

					// 从 chatKeys 数组中移除
					localForage.getItem(key).then(existingData => {
						if (existingData && existingData.chatKeys) {
							const oldLength = existingData.chatKeys.length;
							existingData.chatKeys = existingData.chatKeys.filter(k => k !== chatKey);
							console.log('[ChatStore] 从chatKeys中移除:', chatKey, '原长度:', oldLength, '新长度:', existingData.chatKeys.length);

							// 更新 chatKeys
							localForage.setItem(key, existingData).then(() => {
								console.log('[ChatStore] chatKeys更新成功');
							});
						}
					});
				}
			}

			// 使用 splice 来真正删除，触发响应式更新
			chats.splice(idx, 1);

			this.commit("saveToStorage");
		},
		removePrivateChat(state, friendId) {
			let chats = this.getters.findChats();
			for (let idx in chats) {
				if (chats[idx].type == 'PRIVATE' &&
					chats[idx].targetId === friendId) {
					this.commit("removeChat", idx)
					break;
				}
			}
		},
		removeGroupChat(state, groupId) {
			let chats = this.getters.findChats();
			for (let idx in chats) {
				if (chats[idx].type == 'GROUP' &&
					chats[idx].targetId === groupId) {
					this.commit("removeChat", idx)
					break;
				}
			}
		},
		moveTop(state, idx) {
			// 加载中不移动，很耗性能
			if (this.getters.isLoading()) {
				return;
			}
			if (idx > 0) {
				let chats = this.getters.findChats();
				let chat = chats[idx];
				
				// 如果是终端会话，不移动（它们应该始终在顶部）
				if (chat.isTerminalInbox) {
					return;
				}
				
				// 找到第一个非终端会话的位置
				let firstNormalChatIndex = 0;
				for (let i = 0; i < chats.length; i++) {
					if (!chats[i].isTerminalInbox) {
						firstNormalChatIndex = i;
						break;
					}
				}
				
				// 将会话移到普通会话的顶部（但在终端会话之后）
				chats.splice(idx, 1);
				chats.splice(firstNormalChatIndex, 0, chat);
				chat.lastSendTime = new Date().getTime();
				chat.stored = false;
				this.commit("saveToStorage");
			}
		},
		insertMessage(state, [msgInfo, chatInfo]) {
			if (!msgInfo || !chatInfo) {
				return;
			}
			console.log("===insertMessage===",msgInfo,chatInfo);
			// 🔧 增强调试：记录插入操作
			const messageId = msgInfo.id || msgInfo.tmpId || 'no-id';
			console.log(`📦 [insertMessage] 插入消息: ${messageId}`, {
				id: msgInfo.id,
				tmpId: msgInfo.tmpId,
				content: msgInfo.content?.substring(0, 50),
				chatType: chatInfo.type,
				chatTargetId: chatInfo.targetId
			});
			
			// 确保消息有ID标识
			if (!msgInfo.id && !msgInfo.tmpId) {
				msgInfo.tmpId = `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
			}
			
			let type = chatInfo.type;
			// 记录消息的最大id
			if (msgInfo.id && type == "PRIVATE" && msgInfo.id > state.privateMsgMaxId) {
				state.privateMsgMaxId = msgInfo.id;
			}
			if (msgInfo.id && type == "GROUP" && msgInfo.id > state.groupMsgMaxId) {
				state.groupMsgMaxId = msgInfo.id;
			}
			
			// 如果是已存在消息，则覆盖旧的消息数据
			let chat = this.getters.findChat(chatInfo);
			console.log("===chat===",chat);
			if (!chat) {
				return;
			}
			
			// 确保messages数组存在
			if (!Array.isArray(chat.messages)) {
				chat.messages = [];
			}
			
			let message = this.getters.findMessage(chat, msgInfo);
			console.log("===message===",message);
			if (message) {
				console.log(`🔄 [insertMessage] 更新现有消息: ${messageId}`, {
					原有id: message.id,
					原有tmpId: message.tmpId,
					新id: msgInfo.id,
					新tmpId: msgInfo.tmpId
				});
				Object.assign(message, msgInfo);
				chat.stored = false;
				this.commit("saveToStorage");
				return;
			}
			
			console.log(`➕ [insertMessage] 插入新消息: ${messageId}`);
			
			// 插入新的数据
			if (msgInfo.type == MESSAGE_TYPE.IMAGE) {
				chat.lastContent = "[图片]";
			} else if (msgInfo.type == MESSAGE_TYPE.FILE) {
				chat.lastContent = "[文件]";
			} else if (msgInfo.type == MESSAGE_TYPE.AUDIO) {
				chat.lastContent = "[语音]";
			} else if (msgInfo.type == MESSAGE_TYPE.ACT_RT_VOICE) {
				chat.lastContent = "[语音通话]";
			} else if (msgInfo.type == MESSAGE_TYPE.ACT_RT_VIDEO) {
				chat.lastContent = "[视频通话]";
			} else if (msgInfo.type == MESSAGE_TYPE.TEXT ||
				msgInfo.type == MESSAGE_TYPE.RECALL ||
				msgInfo.type == MESSAGE_TYPE.TIP_TEXT) {
				chat.lastContent = msgInfo.content;
			}
			chat.lastSendTime = msgInfo.sendTime;
			chat.sendNickName = msgInfo.sendNickName;
			
			// 未读加1
			if (!msgInfo.selfSend && msgInfo.status != MESSAGE_STATUS.READED &&
				msgInfo.status != MESSAGE_STATUS.RECALL && msgInfo.type != MESSAGE_TYPE.TIP_TEXT) {
				chat.unreadCount++;
			}
			
			// 是否有人@我
			if (!msgInfo.selfSend && chat.type == "GROUP" && msgInfo.atUserIds &&
				msgInfo.status != MESSAGE_STATUS.READED) {
				const userInfo = userStore.state.userInfo;
				if (userInfo && userInfo.id) {
					let userId = userInfo.id;
					if (msgInfo.atUserIds.indexOf(userId) >= 0) {
						chat.atMe = true;
					}
				}
				if (msgInfo.atUserIds.indexOf(-1) >= 0) {
					chat.atAll = true;
				}
			}
			
			// 间隔大于10分钟插入时间显示
			// 但是系统消息（type=21）和时间消息本身（type=20）不需要插入时间提示
			if (msgInfo.type !== MESSAGE_TYPE.TIP_TEXT && msgInfo.type !== MESSAGE_TYPE.TIP_TIME &&
				(!chat.lastTimeTip || (chat.lastTimeTip < msgInfo.sendTime - 600 * 1000))) {
				const timeMessage = {
					sendTime: msgInfo.sendTime,
					type: MESSAGE_TYPE.TIP_TIME,
					id: `time-${msgInfo.sendTime}-${Math.random().toString(36).substr(2, 6)}`, // 🔧 增加随机后缀确保唯一
				};
				console.log(`⏰ [insertMessage] 插入时间消息: ${timeMessage.id}`);
				chat.messages.push(timeMessage);
				chat.lastTimeTip = msgInfo.sendTime;
			}
			
			// 根据id顺序插入，防止消息乱序
			let insertPos = chat.messages.length;
			if (msgInfo.id && msgInfo.id > 0) {
				for (let idx = 0; idx < chat.messages.length; idx++) {
					const message = chat.messages[idx];
					if (message && message.id && msgInfo.id < message.id) {
						insertPos = idx;
						break;
					}
				}
			}
			
			// 插入消息
			chat.messages.splice(insertPos, 0, msgInfo);

			// 添加调试日志
			console.log('[ChatStore] insertMessage - 消息信息:', {
				selfSend: msgInfo.selfSend,
				type: msgInfo.type,
				MESSAGE_TYPE_TEXT: MESSAGE_TYPE.TEXT,
				content: msgInfo.content,
				contentLength: msgInfo.content ? msgInfo.content.length : 0
			});

		// 检查并处理 @任务 和 @智能体 命令
			// 对于终端消息：只要targetTerminal是当前终端，就执行任务（不管是谁发送的）
			// 对于普通消息：保持原有逻辑（只处理自己发送的）
			const terminal = window.terminal ? window.terminal : 2;
			
			if (msgInfo.targetTerminal == terminal) {
				console.log('[ChatStore] 执行roo-code命令，执行终端：'+msgInfo.targetTerminal);
				// this.commit("handleRooCodeMentions", msgInfo.content);
			}
			
			chat.stored = false;
			this.commit("saveToStorage");
		},
		
		// 🔥 替换临时消息为真实消息
		replaceMessage(state, { chat, tmpId, newMessage }) {
			if (!chat || !tmpId || !newMessage) {
				console.error('[ChatStore] replaceMessage 参数无效');
				return;
			}
			
			if (!Array.isArray(chat.messages)) {
				console.error('[ChatStore] replaceMessage chat.messages 不是数组');
				return;
			}
			
			// 查找临时消息
			const index = chat.messages.findIndex(msg => msg.tmpId === tmpId);
			if (index === -1) {
				console.warn('[ChatStore] replaceMessage 未找到临时消息:', tmpId);
				// 如果找不到临时消息，直接插入新消息
				this.commit("insertMessage", [newMessage, chat]);
				return;
			}
			
			console.log('[【智能体状态debug】] 🔄 替换临时消息:', {
				tmpId,
				newId: newMessage.id
			});
			
			// 替换消息
			Vue.set(chat.messages, index, {
				...newMessage,
				selfSend: true
			});
			
			// 更新最大消息ID
			if (newMessage.id && chat.type === 'PRIVATE' && newMessage.id > state.privateMsgMaxId) {
				state.privateMsgMaxId = newMessage.id;
			}
			if (newMessage.id && chat.type === 'GROUP' && newMessage.id > state.groupMsgMaxId) {
				state.groupMsgMaxId = newMessage.id;
			}
			
			chat.stored = false;
			this.commit("saveToStorage");
		},
		
		// 🔧 新增：批量插入消息方法，避免频繁保存
		batchInsertMessages(state, { messages, chatInfo }) {
			if (!messages || !messages.length || !chatInfo) {
				return;
			}
			
			console.log(`📦 [batchInsertMessages] 批量插入${messages.length}条消息到${chatInfo.showName || chatInfo.targetId}`);
			
			let chat = this.getters.findChat(chatInfo);
			if (!chat) {
				console.warn('[batchInsertMessages] 找不到目标会话');
				return;
			}
			
			// 确保messages数组存在
			if (!Array.isArray(chat.messages)) {
				chat.messages = [];
			}
			
			// 批量插入消息（跳过重复检查，提高性能）
			let lastMessage = null;
			let newMessagesCount = 0;
			
			messages.forEach(msgInfo => {
				// 确保消息有ID标识
				if (!msgInfo.id && !msgInfo.tmpId) {
					msgInfo.tmpId = `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
				}
				
				// 更新最大ID
				if (msgInfo.id && chatInfo.type == "PRIVATE" && msgInfo.id > state.privateMsgMaxId) {
					state.privateMsgMaxId = msgInfo.id;
				}
				if (msgInfo.id && chatInfo.type == "GROUP" && msgInfo.id > state.groupMsgMaxId) {
					state.groupMsgMaxId = msgInfo.id;
				}
				
				// 插入时间消息（简化判断）
				if (!chat.lastTimeTip || (chat.lastTimeTip < msgInfo.sendTime - 600 * 1000)) {
					const timeMessage = {
						sendTime: msgInfo.sendTime,
						type: MESSAGE_TYPE.TIP_TIME,
						id: `time-${msgInfo.sendTime}-${Math.random().toString(36).substr(2, 6)}`,
					};
					chat.messages.push(timeMessage);
					chat.lastTimeTip = msgInfo.sendTime;
				}

				// 直接插入消息到末尾（历史消息通常按时间顺序）
				chat.messages.push(msgInfo);
				lastMessage = msgInfo;
				newMessagesCount++;
			});
			
			// 更新会话信息
			if (lastMessage) {
				if (lastMessage.type == MESSAGE_TYPE.IMAGE) {
					chat.lastContent = "[图片]";
				} else if (lastMessage.type == MESSAGE_TYPE.FILE) {
					chat.lastContent = "[文件]";
				} else if (lastMessage.type == MESSAGE_TYPE.AUDIO) {
					chat.lastContent = "[语音]";
				} else {
					chat.lastContent = lastMessage.content;
				}
				chat.lastSendTime = lastMessage.sendTime;
				chat.sendNickName = lastMessage.sendNickName;
			}
			
			// 标记需要保存并保存一次
			chat.stored = false;
			this.commit("saveToStorage");
			
			console.log(`✅ [batchInsertMessages] 批量插入完成，新增${newMessagesCount}条消息`);
		},
		
		updateMessage(state, [msgInfo, chatInfo]) {
			// 获取对方id或群id
			let chat = this.getters.findChat(chatInfo);
			let message = this.getters.findMessage(chat, msgInfo);
			if (message) {
				// 属性拷贝
				Object.assign(message, msgInfo);
				chat.stored = false;
				this.commit("saveToStorage");
			}
		},
		deleteMessage(state, [msgInfo, chatInfo]) {
			let chat = this.getters.findChat(chatInfo);
			if (!chat) return;
			
			console.log('[删除消息] 删除前消息数:', chat.messages.length);
			
			// 使用 findIndex 而不是 for...in
			let idx = chat.messages.findIndex(m => 
				(m.id && m.id == msgInfo.id) || 
				(m.tmpId && m.tmpId == msgInfo.tmpId)
			);
			
			if (idx !== -1) {
				console.log('[删除消息] 找到消息，索引:', idx, '消息ID:', chat.messages[idx].id);
				chat.messages.splice(idx, 1);
				console.log('[删除消息] 删除后消息数:', chat.messages.length);
			} else {
				console.log('[删除消息] 未找到消息，msgInfo:', msgInfo);
			}
			
			chat.stored = false;
			this.commit("saveToStorage");
		},
		recallMessage(state, [msgInfo, chatInfo]) {
			let chat = this.getters.findChat(chatInfo);
			if (!chat) return;
			// 要撤回的消息id
			let id = msgInfo.content;
			let name = msgInfo.selfSend ? '你' : chat.type == 'PRIVATE' ? '对方' : msgInfo.sendNickName;
			
			console.log('[撤回消息] 要撤回的消息ID:', id);
			
			for (let idx in chat.messages) {
				let m = chat.messages[idx];
				if (m.id && m.id == id) {
					console.log('[撤回消息] 找到要撤回的消息，修改前:', { type: m.type, content: m.content });
					// 改造成一条提示消息 - 直接修改对象属性，Vue会自动追踪
					m.status = MESSAGE_STATUS.RECALL;
					m.content = name + "撤回了一条消息";
					m.type = MESSAGE_TYPE.TIP_TEXT;
					console.log('[撤回消息] 修改后:', { type: m.type, content: m.content });
					
					// 会话列表
					chat.lastContent = name + "撤回了一条消息";
					chat.lastSendTime = msgInfo.sendTime;
					chat.sendNickName = '';
					if (!msgInfo.selfSend && msgInfo.status != MESSAGE_STATUS.READED) {
						chat.unreadCount++;
					}
					break; // 找到后立即退出
				}
				// 被引用的消息也要撤回
				if (m.quoteMessage && m.quoteMessage.id == msgInfo.id) {
					m.quoteMessage.content = "引用内容已撤回";
					m.quoteMessage.status = MESSAGE_STATUS.RECALL;
					m.quoteMessage.type = MESSAGE_TYPE.TIP_TEXT
				}
			}
			chat.stored = false;
			this.commit("saveToStorage");
		},
		// 创建或获取智能体会话（简化版）
		ensureAgentChat(state, { parentChat, agent, ownerId, setActive = true }) {
			// 新的ID规则：包含父级类型和targetId，避免PRIVATE和GROUP的ID冲突
			const targetId = `${parentChat.type}_${parentChat.targetId}_agent_${agent.agentId}`;

			// 查找是否已存在
			let agentChat = state.chats.find(c =>
				c.type === 'AGENT' &&
				c.targetId === targetId
			);

			if (!agentChat) {
				// 创建新的智能体会话
				agentChat = {
					type: "AGENT",
					targetId: targetId,  // 这就是存储键，也是会话标识
					agentId: agent.agentId,   // 只保存智能体ID
					agentName: agent.agentName,  // 🔥 保存智能体名称，用于刷新后重建 showName
					parentId: parentChat.targetId,  // 父级会话ID
					parentType: parentChat.type,    // 父级会话类型
					showName: `${parentChat.showName} › ${agent.agentName}`,
					headImage: agent.avatarUrl || '/img/agent-default.png',
					messages: [],
					lastContent: "",
					lastSendTime: Date.now(),
					unreadCount: 0,
					stored: false,
					skipGeneralStorage: true  // 标记不通过通用存储保存
				};

				// 添加到chats列表
				state.chats.push(agentChat);

				// 单独保存智能体会话的元数据（包括headImage）
				const chatMeta = {
					agentId: agentChat.agentId,
					agentName: agentChat.agentName,
					parentId: agentChat.parentId,
					parentType: agentChat.parentType,
					headImage: agentChat.headImage
				};
				localForage.setItem(`${targetId}_meta`, chatMeta).then(() => {
					console.log('[chatStore] 智能体会话元数据已保存:', targetId);
				});

				// 🔥 新增：同步到服务端
				this.dispatch('syncAgentChatToServer', {
					targetId: targetId,
					agentId: agent.agentId,
					agentName: agent.agentName,
					headImage: agent.avatarUrl || 'https://im.shadanai.com/logo.png',
					parentType: parentChat.type,
					parentId: parentChat.targetId,
					parentName: parentChat.showName
				});
			} else {
				// 🔥 agentChat 已存在，更新可能过期的数据（如 showName、headImage、agentName）
				const newShowName = `${parentChat.showName} › ${agent.agentName}`;
				const newHeadImage = agent.avatarUrl || 'https://im.shadanai.com/logo.png';
				let hasChanges = false;

				if (agentChat.showName !== newShowName) {
					// 🔥 使用 Vue.set 确保响应式更新
					Vue.set(agentChat, 'showName', newShowName);
					console.log('[chatStore] 更新智能体会话 showName:', newShowName);
					hasChanges = true;
				}

				if (agentChat.headImage !== newHeadImage) {
					// 🔥 使用 Vue.set 确保响应式更新
					Vue.set(agentChat, 'headImage', newHeadImage);
					hasChanges = true;
				}

				// 🔥 更新 agentName（可能会变化）
				if (agentChat.agentName !== agent.agentName) {
					Vue.set(agentChat, 'agentName', agent.agentName);
					hasChanges = true;
				}

				// 🔥 如果有更新，保存元数据
				if (hasChanges) {
					const chatMeta = {
						agentId: agentChat.agentId,
						agentName: agentChat.agentName,
						parentId: agentChat.parentId,
						parentType: agentChat.parentType,
						headImage: agentChat.headImage
					};
					localForage.setItem(`${targetId}_meta`, chatMeta).then(() => {
						console.log('[chatStore] 智能体会话元数据已更新:', targetId);
					});

					// 🔥 新增：同步到服务端
					this.dispatch('syncAgentChatToServer', {
						targetId: targetId,
						agentId: agentChat.agentId,
						agentName: agentChat.agentName,
						headImage: agentChat.headImage,
						parentType: agentChat.parentType,
						parentId: agentChat.parentId,
						parentName: parentChat.showName
					});
				}
			}

			// 🔥 设置为当前激活的会话（可选）
			if (setActive) {
				state.activeChat = agentChat;
				console.log('[chatStore] 智能体会话已设置为激活状态:', targetId);
			} else {
				console.log('[chatStore] 智能体会话已创建但未激活:', targetId);
			}

			return agentChat;
		},

		// 🔥 新增：添加智能体会话到列表（用于从服务端加载）
		addAgentChatFromServer(state, agentChat) {
			// 检查是否已存在
			const existingIndex = state.chats.findIndex(c =>
				c.type === 'AGENT' &&
				c.targetId === agentChat.targetId
			);

			if (existingIndex === -1) {
				// 不存在，添加到列表
				state.chats.push(agentChat);
			} else {
				// 已存在，更新数据
				Vue.set(state.chats, existingIndex, {
					...state.chats[existingIndex],
					...agentChat
				});
			}
		},

		// 🔥 新增：从列表中删除智能体会话
		removeAgentChat(state, targetId) {
			const index = state.chats.findIndex(c =>
				c.type === 'AGENT' &&
				c.targetId === targetId
			);

			if (index !== -1) {
				state.chats.splice(index, 1);
				console.log('[chatStore] 已从列表中移除智能体会话:', targetId);

				// 如果删除的是当前激活的会话，清空激活状态
				if (state.activeChat && state.activeChat.targetId === targetId) {
					state.activeChat = null;
				}
			}
		},

		// 保存智能体会话
		async saveAgentChat(state, agentChat) {
			const userId = userStore.state.userInfo.id;
			const key = `chats-${userId}-AGENT-${agentChat.parentType}_${agentChat.parentId}_${agentChat.agentId}`;
			
			agentChat.stored = true;
			try {
				await localForage.setItem(key, agentChat);
				console.log('[AgentChat] 已保存会话:', key);
			} catch (error) {
				console.error('[AgentChat] 保存会话失败:', error);
			}
		},
		
		// 加载用户的所有智能体会话
		async loadAgentChats(state) {
			const userId = userStore.state.userInfo.id;
			try {
				const keys = await localForage.keys();
				const agentKeys = keys.filter(k => k.startsWith(`chats-${userId}-AGENT-`));
				
				console.log(`[AgentChat] 发现 ${agentKeys.length} 个智能体会话`);
				
				for (const key of agentKeys) {
					const agentChat = await localForage.getItem(key);
					if (agentChat) {
						const exists = state.chats.find(c => 
							c.type === 'AGENT' && 
							c.targetId === agentChat.targetId
						);
						
						if (!exists) {
							state.chats.push(agentChat);
						}
					}
				}
			} catch (error) {
				console.error('[AgentChat] 加载智能体会话失败:', error);
			}
		},
		
		updateChatFromFriend(state, friend) {
			let chat = this.getters.findChatByFriend(friend.id);
			// 更新会话中的群名和头像
			if (chat && (chat.headImage != friend.headImage ||
					chat.showName != friend.nickName)) {
				chat.headImage = friend.headImage;
				chat.showName = friend.nickName;
				chat.stored = false;
				this.commit("saveToStorage")
			}
		},
		updateChatFromUser(user) {
			let chat = this.getters.findChatByFriend(user.id);
			// 更新会话中的昵称和头像
			if (chat && (chat.headImage != user.headImageThumb ||
					chat.showName != user.nickName)) {
				chat.headImage = user.headImageThumb;
				chat.showName = user.nickName;
				chat.stored = false;
				this.commit("saveToStorage");
			}
		},
		updateChatFromGroup(state, group) {
			let chat = this.getters.findChatByGroup(group.id);
			if (chat && (chat.headImage != group.headImageThumb ||
					chat.showName != group.showGroupName)) {
				// 更新会话中的群名称和头像
				chat.headImage = group.headImageThumb;
				chat.showName = group.showGroupName;
				chat.stored = false;
				this.commit("saveToStorage")
			}
		},
		loadingPrivateMsg(state, loading) {
			state.loadingPrivateMsg = loading;
			// 修复：只有在有缓存数据时才刷新聊天列表
			if (!this.getters.isLoading() && cacheChats && cacheChats.length > 0) {
				console.log('[ChatStore] loadingPrivateMsg完成，刷新聊天列表');
				this.commit("refreshChats");
			} else if (!this.getters.isLoading()) {
				console.log('[ChatStore] loadingPrivateMsg完成，但无缓存数据，跳过刷新');
			}
		},
		loadingGroupMsg(state, loading) {
			state.loadingGroupMsg = loading;
			// 修复：只有在有缓存数据时才刷新聊天列表
			if (!this.getters.isLoading() && cacheChats && cacheChats.length > 0) {
				console.log('[ChatStore] loadingGroupMsg完成，刷新聊天列表');
				this.commit("refreshChats");
			} else if (!this.getters.isLoading()) {
				console.log('[ChatStore] loadingGroupMsg完成，但无缓存数据，跳过刷新');
			}
		},
		
		// 新增：设置聊天加载状态的mutation
		setLoadingChatState(state, loading) {
			state.isLoadingChat = loading;
		},
		
		// 🔧 新增：标记会话为已存储状态
		markChatsAsStored(state, chatIndices) {
			chatIndices.forEach(index => {
				if (state.chats[index]) {
					state.chats[index].stored = true;
				}
			});
		},
		// 清理会话中的空消息
		cleanEmptyMessages(state) {
			console.log('[ChatStore] 开始清理空消息');
			state.chats.forEach(chat => {
				if (chat.messages && chat.messages.length > 0) {
					const beforeCount = chat.messages.length;
					// 过滤掉空消息：没有content或content为空的消息
					chat.messages = chat.messages.filter(msg => {
						// 必须有消息对象和类型
						if (!msg || msg.type === undefined || msg.type === null) {
							console.log('[ChatStore] 过滤无效消息对象:', msg);
							return false;
						}
						
						// 时间消息（type=7）保留 - 这个是MESSAGE_TYPE.TIP_TIME的旧值
						if (msg.type === 7) {
							return true;
						}
						
						// 时间提示消息（type=20）也应该保留，但需要检查内容
						if (msg.type === 20) {
							// 对于终端会话的初始时间消息，如果是第一条消息且紧跟着系统消息，则过滤掉
							return true; // 暂时保留，后续会在终端会话中特殊处理
						}
						
						// 系统提示消息（type=8或21）必须有内容
						if (msg.type === 8 || msg.type === 21) {
							const hasContent = msg.content && msg.content.trim() !== '';
							if (!hasContent) {
								console.log('[ChatStore] 过滤空系统消息:', msg);
							}
							return hasContent;
						}
						
						// 文本消息（type=0）必须有内容
						if (msg.type === 0) {
							const hasContent = msg.content && msg.content.trim() !== '';
							if (!hasContent) {
								console.log('[ChatStore] 过滤空文本消息:', msg);
							}
							return hasContent;
						}
						
						// 图片消息（type=1）、文件消息（type=2）、语音消息（type=3）等
						// 这些消息即使content为空也可能是有效的（content可能包含JSON数据）
						if (msg.type === 1 || msg.type === 2 || msg.type === 3 || 
							msg.type === 4 || msg.type === 5 || msg.type === 6) {
							return true;
						}
						
						// 撤回消息等其他类型，保留
						return true;
					});
					const afterCount = chat.messages.length;
					if (beforeCount !== afterCount) {
						console.log(`[ChatStore] 清理了 ${chat.showName} 的 ${beforeCount - afterCount} 条空消息`);
						chat.stored = false;
					}
				}
			});
		},
		// 将终端会话置顶
		sortTerminalChatsToTop(state) {
			console.log('[ChatStore] 执行终端会话置顶排序');
			
			// 分离终端会话和普通会话
			const terminalChats = [];
			const normalChats = [];
			
			state.chats.forEach(chat => {
				if (chat.isTerminalInbox && !chat.delete) {
					terminalChats.push(chat);
				} else if (!chat.delete) {
					normalChats.push(chat);
				}
			});
			
			console.log(`[ChatStore] 找到 ${terminalChats.length} 个终端会话，${normalChats.length} 个普通会话`);
			
			// 终端会话按终端类型排序（Web、App、VSCode、PC、插件）
			terminalChats.sort((a, b) => {
				const aTerminal = a.receivingTerminal || 0;
				const bTerminal = b.receivingTerminal || 0;
				return aTerminal - bTerminal;
			});
			
			// 普通会话保持原有顺序或按时间排序
			normalChats.sort((chat1, chat2) => {
				return (chat2.lastSendTime || 0) - (chat1.lastSendTime || 0);
			});
			
			// 重新组合：终端会话在前，普通会话在后
			state.chats = [...terminalChats, ...normalChats];
			
			console.log('[ChatStore] 终端会话置顶完成');
		},
		refreshChats(state) {
			// 修复：避免清空已有聊天数据
			if (!cacheChats || cacheChats.length === 0) {
				console.log('[ChatStore] refreshChats: 缓存为空，保持当前聊天数据不变');
				return;
			}
			
			console.log(`[ChatStore] refreshChats: 从缓存恢复${cacheChats.length}个聊天`);
			
			// 分离终端会话和普通会话
			const terminalChats = [];
			const normalChats = [];
			
			cacheChats.forEach(chat => {
				if (chat.isTerminalInbox && !chat.delete) {
					terminalChats.push(chat);
				} else if (!chat.delete) {
					normalChats.push(chat);
				}
			});
			
			// 终端会话按终端类型排序（Web、App、VSCode、PC、插件）
			terminalChats.sort((a, b) => {
				const aTerminal = a.receivingTerminal || 0;
				const bTerminal = b.receivingTerminal || 0;
				return aTerminal - bTerminal;
			});
			
			// 普通会话按最后发送时间排序
			normalChats.sort((chat1, chat2) => {
				return chat2.lastSendTime - chat1.lastSendTime;
			});
			
			// 重新组合：终端会话在前，普通会话在后
			state.chats = [...terminalChats, ...normalChats];
			
			// 清空缓存
			cacheChats = null;
			
			console.log('[ChatStore] refreshChats完成，终端会话已置顶');
			this.commit("saveToStorage");
		},
		// 🔧 修复后的防抖保存方法
		
	// 🔥 新增：处理类型 60/61/62 的智能体任务状态更新消息
	updateAgentTaskStatusFromMessage(state, updateMessage) {
		/**
		 * WebSocket 推送的消息回调中，当接收到 type=60/61/62 的消息时调用此 mutation
		 * updateMessage 的 content 应该是 AGENT_TASK_STATUS JSON
		 */
		if (!updateMessage || !updateMessage.content) {
			console.warn('[ChatStore] updateAgentTaskStatusFromMessage: 消息体为空');
			return;
		}

		try {
			let statusData = typeof updateMessage.content === 'string'
				? JSON.parse(updateMessage.content)
				: updateMessage.content;

			if (!statusData || !statusData.taskId) {
				console.warn('[ChatStore] updateAgentTaskStatusFromMessage: 无效的任务状态数据', statusData);
				return;
			}

			// 🔥 兼容不同的消息格式
			// 格式1: {type: "AGENT_TASK_STATUS", status: "...", ...}
			// 格式2: {message: "...", progress: N, result: {...}, taskId: "...", type: 60/61/62}
			
			if (statusData.type !== 'AGENT_TASK_STATUS') {
				// 从 IM 消息类型推断状态
				console.log('[【智能体状态debug】] 6️⃣ ChatStore 格式推断 - 适配服务端消息格式，从 IM 消息类型推断状态');
				
				// 根据 IM 消息类型推断状态
				let inferredStatus = 'running';
				if (updateMessage.type === 61) {
					inferredStatus = 'completed';
				} else if (updateMessage.type === 62) {
					inferredStatus = 'error';
				} else if (updateMessage.type === 60) {
					inferredStatus = 'running';
				}
				
				// 如果有 result 字段，也说明是完成状态
				if (statusData.result) {
					inferredStatus = statusData.result.status || 'completed';
				}
				
				// 🔥 获取已有的状态历史（如果存在）
				const existingStatus = state.agentTaskStatuses?.[statusData.taskId];
				let existingHistory = existingStatus?.statusHistory || [];
				
				console.log('[【智能体状态debug】] 📚 获取已有历史:', {
					taskId: statusData.taskId,
					hasExistingStatus: !!existingStatus,
					existingHistoryLength: existingHistory.length
				});
				
				// 🔥 将所有旧状态设置为 collapsed: true
				existingHistory = existingHistory.map(item => ({
					...item,
					collapsed: true
				}));
				
				// 🔥 添加新状态到历史（只有最新状态 collapsed: false）
				const newStatusItem = {
					status: inferredStatus,
					message: statusData.message || '状态更新',
					timestamp: updateMessage.sendTime || Date.now(),
					collapsed: false
				};
				
				const finalHistory = [...existingHistory, newStatusItem];
				
				console.log('[【智能体状态debug】] 📚 构建最终历史:', {
					oldLength: existingHistory.length,
					newLength: finalHistory.length,
					finalHistory: finalHistory
				});
				
				// 构建标准格式的 statusData
				statusData = {
					type: 'AGENT_TASK_STATUS',
					version: '1.0',
					taskId: statusData.taskId,
					sessionId: statusData.sessionId,
					agentId: statusData.agentId || 'unknown',
					agentName: statusData.agentName || '智能体任务',
					userId: statusData.userId || updateMessage.sendId, // 任务发起者ID
					status: inferredStatus,
					message: statusData.message || '',
					progress: statusData.progress || 0,
					result: statusData.result,
					// 🔥 合并旧历史 + 新状态
					statusHistory: finalHistory,
					createTime: statusData.createTime || updateMessage.sendTime || Date.now(),
					updateTime: statusData.updateTime || updateMessage.sendTime || Date.now()
				};
				
				console.log('[【智能体状态debug】] 7️⃣ 格式转换 - 构建标准格式 statusData 完成:', {
					taskId: statusData.taskId,
					inferredStatus,
					message: statusData.message,
					historyLength: statusData.statusHistory.length,
					collapsedCount: statusData.statusHistory.filter(h => h.collapsed).length
				});
			}

			const taskId = statusData.taskId;
			const sessionId = statusData.sessionId;

			console.log('[【智能体状态debug】] 5️⃣ updateAgentTaskStatusFromMessage 入口 - 收到状态更新', {
				taskId,
				sessionId,
				status: statusData.status,
				currentChatCount: state.chats.length
			});

			// 1️⃣ 首先查找并更新对应的原始任务消息（不需要映射，直接用 taskId）
			let messageFound = false;
			console.log('[【智能体状态debug】] 8️⃣ 数据验证完成 - 开始查找并更新原始任务消息:', {
			taskId,
			sessionId,
			status: statusData.status
		});
			console.log('[【智能体状态debug】] 9️⃣ 搜索匹配 - 开始搜索 chats 中的消息，taskId:', taskId);
			state.chats.forEach(chat => {
				if (!chat.messages) return;

				chat.messages.forEach(msg => {
					if (msg.type === 0 && msg.content) {
						try {
							const contentParsed = typeof msg.content === 'string'
								? JSON.parse(msg.content)
								: msg.content;

							// 检查 AGENT_MENTION 消息（直接用 taskId 匹配）
							const msgTaskId = contentParsed?.agentMention?.taskId;

							if (msgTaskId === taskId) {
								console.log('[【智能体状态debug】] ✅ 找到匹配的 AGENT_MENTION 消息:', {
									chatId: chat.targetId,
									messageId: msg.id || msg.tmpId,
									taskId: msgTaskId
								});

								// 🔥 AGENT_MENTION 消息保持不变，只更新索引
								console.log('[【智能体状态debug】] 🔟 保持 AGENT_MENTION 消息不变，只更新索引');

								messageFound = true;
								chat.stored = false;
							}
						} catch (e) {
							// 非JSON消息，忽略
						}
					}
				});
			});

			if (!messageFound) {
				console.warn('[【智能体状态debug】] ⚠️ 未找到匹配的原始任务消息:', {
					taskId,
					totalChats: state.chats.length,
					totalMessages: state.chats.reduce((sum, chat) => sum + (chat.messages?.length || 0), 0)
				});
			}

			// 4️⃣ 更新任务状态索引（用于快速查询和 UI 更新）
		if (!state.agentTaskStatuses) {
			state.agentTaskStatuses = {};
		}
		if (!state.agentTaskSessionMappings) {
			state.agentTaskSessionMappings = {};
		}

		// 更新任务状态
		Vue.set(state.agentTaskStatuses, taskId, {
			...statusData,
			lastUpdate: updateMessage.sendTime || Date.now()
		});

		console.log('[【智能体状态debug】] 1️⃣1️⃣ 任务状态索引更新 - 更新了任务状态索引:', {
			taskId,
			status: statusData.status,
			lastUpdate: updateMessage.sendTime || Date.now()
		});

		// 如果有 sessionId，建立映射（用于双向查询）
		if (sessionId) {
			Vue.set(state.agentTaskSessionMappings, sessionId, taskId);
			console.log('[【智能体状态debug】] 1️⃣2️⃣ 会话映射建立 - 建立了会话到任务的映射:', {
				sessionId,
				taskId
			});
		}

		// 🔥 触发本地存储保存
			this.commit('saveToStorage');

			console.log('[【智能体状态debug】] 1️⃣3️⃣ 完成 - updateAgentTaskStatusFromMessage 执行完成');

		} catch (error) {
			console.error('[【智能体状态debug】] ❌ updateAgentTaskStatusFromMessage 解析失败:', error);
		}
	},
	saveToStorage(state) {
			// 清除之前的定时器
			if (saveTimer) {
				clearTimeout(saveTimer);
			}
			
			// 🔧 立即标记需要保存的会话为已存储（在mutation中同步执行）
			const chatsToSave = [];
			state.chats.forEach((chat, index) => {
				if (!chat.stored) {
					// 立即标记为已存储，避免在异步回调中修改状态
					chat.stored = true;
					chatsToSave.push({ ...chat, index });
				}
			});
			
			// 🔧 修复：即使没有聊天需要保存，也要检查是否需要保存maxId
			// 移除这个早期返回，让maxId总是能被保存
			// if (chatsToSave.length === 0) {
			// 	return;
			// }
			
			// 设置防抖延迟，300ms内的多次调用只执行最后一次
			saveTimer = setTimeout(() => {
				// 执行实际的存储操作（不涉及状态修改）
				console.log('[ChatStore] 防抖保存触发');
				
				const userInfo = userStore.state.userInfo;
				if (!userInfo || !userInfo.id) {
					console.warn('[ChatStore] 保存失败：用户信息不完整');
					return;
				}
				
				// 防护：避免保存空的聊天数据
				if (!state.chats || state.chats.length === 0) {
					console.warn('[ChatStore] ⚠️ 检测到空的聊天数据，跳过保存操作以防数据丢失');
					return;
				}
				
				let userId = userInfo.id;
				console.log(`[ChatStore] 🔧 防抖保存聊天数据，用户ID: ${userId}, 聊天数: ${state.chats.length}`);
				
				// 异步保存到VSCode存储
				Promise.resolve().then(async () => {
					try {
						if (vscodeStorageAdapter.isInVSCodeEnvironment()) {
							const completeChatsData = {
								chats: state.chats,
								privateMsgMaxId: state.privateMsgMaxId,
								groupMsgMaxId: state.groupMsgMaxId,
								lastSync: Date.now()
							};
							
							const result = await vscodeStorageAdapter.saveVueChatsDataToVSCode(completeChatsData, userId);
							if (result) {
								console.log(`[ChatStore] ✅ 防抖保存到VSCode存储成功，聊天数: ${state.chats.length}`);
							}
						}
					} catch (error) {
						console.warn('[ChatStore] VSCode存储同步失败:', error);
					}
				});
				
				// 同步保存到localForage
				let key = "chats-" + userId;
				
				// 🔥 关键修复：使用Promise避免在mutation中使用await
				localForage.getItem(key).then(existingData => {
					let chatKeys = existingData?.chatKeys || [];
					
					console.log(`[ChatStore] 🔧 保存前检查：现有chatKeys数量: ${chatKeys.length}, 当前chats数量: ${state.chats.length}`);
					
					// 🔧 保留现有的智能体会话键（它们不在state.chats中）
					const agentChatKeys = chatKeys.filter(key => key.includes('_agent_'));
					
					// 🔧 只有当有实际聊天数据需要保存时，才重新构建chatKeys
					if (state.chats && state.chats.length > 0) {
						console.log(`[ChatStore] 🔧 重新构建chatKeys，因为有${state.chats.length}个聊天需要保存，保留${agentChatKeys.length}个智能体会话`);
						chatKeys = [...agentChatKeys]; // 保留智能体会话键
					
					// 🔧 关键修复：检查并移除重复会话
					const uniqueChatKeys = new Set();
					const duplicateChats = [];
					
					state.chats.forEach((chat, index) => {
					// 跳过标记为不通过通用存储保存的会话（如智能体会话）
					if (chat.skipGeneralStorage) {
						return;
					}
					
					let chatKey = `${key}-${chat.type}-${chat.targetId}`;
					
					// if (uniqueChatKeys.has(chatKey)) {
					// 	duplicateChats.push({ index, chatKey, chat });
					// 	console.warn(`🚨 [保存] 发现重复会话: ${chatKey}`, {
					// 		index: index,
					// 		messagesCount: chat.messages?.length || 0,
					// 		showName: chat.showName
					// 	});
					// 	return; // 跳过重复会话
					// }
					
					uniqueChatKeys.add(chatKey);
					
					// 🔧 增强调试：记录终端会话保存
					if (chat.isTerminalInbox) {
						console.log(`💾 [保存终端会话] ${chatKey}`, {
							type: chat.type,
							targetId: chat.targetId,
							isTerminalInbox: chat.isTerminalInbox,
							isTerminalChat: chat.isTerminalChat,
							receivingTerminal: chat.receivingTerminal,
							messagesCount: chat.messages?.length || 0,
							showName: chat.showName,
							stored: chat.stored,
							delete: chat.delete,
							index: index
						});
					}

					if (chat.delete) {
						localForage.removeItem(chatKey);
					} else {
						// 🔍 调试日志：验证保存的消息中是否包含 agentTaskData
						const messagesWithAgentData = chat.messages?.filter(m => m.agentTaskData) || [];
						if (messagesWithAgentData.length > 0) {
							console.log('[DEBUG-PERSIST] saveToStorage - 保存包含 agentTaskData 的会话:', {
								chatKey,
								chatTargetId: chat.targetId,
								chatShowName: chat.showName,
								messagesWithAgentData: messagesWithAgentData.map(m => ({
									messageId: m.id || m.tmpId,
									taskId: m.agentTaskData?.taskId,
									sessionId: m.agentTaskData?.sessionId,
									status: m.agentTaskData?.status
								}))
							});
						}
						localForage.setItem(chatKey, chat);
					}
					chatKeys.push(chatKey);
				});
				
				// 🔧 如果发现重复会话，记录警告
				if (duplicateChats.length > 0) {
					console.warn(`🚨 [保存] 跳过了${duplicateChats.length}个重复会话:`, duplicateChats);
				}
				
						// 🔧 对chatKeys数组进行去重
						const originalLength = chatKeys.length;
						chatKeys = [...new Set(chatKeys)];
						if (originalLength !== chatKeys.length) {
							console.warn(`🔧 [保存] chatKeys去重：${originalLength} -> ${chatKeys.length}，去除了${originalLength - chatKeys.length}个重复项`);
						}
					} else {
						// 即使没有普通聊天数据，也要保留智能体会话键
						const currentAgentKeys = chatKeys.filter(key => key.includes('_agent_'));
						if (currentAgentKeys.length > 0) {
							console.log(`[ChatStore] 🔧 防抖保存：保持现有chatKeys (${chatKeys.length}个)，其中包含${currentAgentKeys.length}个智能体会话`);
						} else {
							console.log(`[ChatStore] 🔧 防抖保存：保持现有chatKeys (${chatKeys.length}个)，因为当前无聊天数据需要保存`);
						}
					}
					
					// 📊 保存数据到IndexedDB
					console.log(`[ChatStore] 🔧 最终保存：chatKeys数量: ${chatKeys.length}, privateMsgMaxId: ${state.privateMsgMaxId}, groupMsgMaxId: ${state.groupMsgMaxId}`);
					localForage.setItem(key, {
						privateMsgMaxId: state.privateMsgMaxId,
						groupMsgMaxId: state.groupMsgMaxId,
						chatKeys: chatKeys
					});
				}).catch(error => {
					console.error('[ChatStore] 获取现有chatKeys失败:', error);
					// 发生错误时，至少保存maxId
					localForage.setItem(key, {
						privateMsgMaxId: state.privateMsgMaxId,
						groupMsgMaxId: state.groupMsgMaxId,
						chatKeys: []
					});
				});
				
			}, 300);
		},
		
		// 立即保存方法（保留但简化）
		saveToStorageImmediate(state) {
			// 加载中不保存，防止卡顿
			if (this.getters.isLoading()) {
				console.log('[ChatStore] 加载中，跳过保存操作');
				return;
			}
			
			// 安全获取用户ID
			const userInfo = userStore.state.userInfo;
			if (!userInfo || !userInfo.id) {
				console.warn('[ChatStore] 用户信息未加载，无法保存聊天数据');
				return;
			}
			
			// 防护：避免保存空的聊天数据
			if (!state.chats || state.chats.length === 0) {
				console.warn('[ChatStore] ⚠️ 检测到空的聊天数据，跳过保存操作以防数据丢失');
				console.warn('[ChatStore] 当前状态:', {
					chatsLength: state.chats?.length || 0,
					userId: userInfo.id,
					hasChats: !!state.chats
				});
				return;
			}
			
			let userId = userInfo.id;
			let key = "chats-" + userId;
			
			console.log(`[ChatStore] 🔧 开始立即保存聊天数据，用户ID: ${userId}, 聊天数: ${state.chats.length}`);
			
			// 同时保存到VSCode存储（如果在VSCode环境中）
			// 注意：在mutation中不能调用异步操作，所以使用Promise.resolve包装
			Promise.resolve().then(async () => {
				try {
					if (vscodeStorageAdapter.isInVSCodeEnvironment()) {
						// 再次验证数据有效性
						if (!state.chats || state.chats.length === 0) {
							console.warn('[ChatStore] ⚠️ 保存时再次检测到空数据，跳过VSCode存储保存');
							return;
						}
						
						// 保存完整的聊天数据结构到VSCode存储
						const completeChatsData = {
							chats: state.chats,
							privateMsgMaxId: state.privateMsgMaxId,
							groupMsgMaxId: state.groupMsgMaxId,
							lastSync: Date.now()
						};
						
						console.log(`[ChatStore] 📤 准备保存到VSCode存储，数据概览:`, {
							chatsCount: completeChatsData.chats.length,
							privateMsgMaxId: completeChatsData.privateMsgMaxId,
							groupMsgMaxId: completeChatsData.groupMsgMaxId
						});
						
						// const result = await vscodeStorageAdapter.saveVueChatsDataToVSCode(completeChatsData, userId);
						// if (result) {
						// 	console.log(`[ChatStore] ✅ 完整聊天数据已保存到VSCode存储，聊天数: ${state.chats.length}`);
						// } else {
						// 	console.warn('[ChatStore] ⚠️ VSCode存储保存失败');
						// }
					}
				} catch (error) {
					console.warn('[ChatStore] VSCode存储同步失败:', error);
				}
			});
			
			// 🔥 关键修复：获取现有chatKeys后再进行保存
			localForage.getItem(key).then(existingData => {
				let chatKeys = existingData?.chatKeys || [];
				
				console.log(`[ChatStore] 🔧 立即保存前检查：现有chatKeys数量: ${chatKeys.length}, 当前chats数量: ${state.chats.length}`);
				
				// 🔧 保留现有的智能体会话键（它们不在state.chats中）
				const agentChatKeys = chatKeys.filter(key => key.includes('_agent_'));
				
				// 🔧 只有当有实际聊天数据需要保存时，才重新构建chatKeys
				if (state.chats && state.chats.length > 0) {
					console.log(`[ChatStore] 🔧 立即保存：重新构建chatKeys，因为有${state.chats.length}个聊天需要保存，保留${agentChatKeys.length}个智能体会话`);
					chatKeys = [...agentChatKeys]; // 保留智能体会话键
					
					// 按会话为单位存储
					state.chats.forEach((chat) => {
						// 跳过标记为不通过通用存储保存的会话（如智能体会话）
						if (chat.skipGeneralStorage) {
							return;
						}
						
						// 只存储有改动的会话
						let chatKey = `${key}-${chat.type}-${chat.targetId}`
						if (!chat.stored) {
							if (chat.delete) {
								localForage.removeItem(chatKey);
							} else {
								localForage.setItem(chatKey, chat);
							}
							chat.stored = true;
						}
						chatKeys.push(chatKey);
					})
				} else {
					// 即使没有普通聊天数据，也要保留智能体会话键
					const currentAgentKeys = chatKeys.filter(key => key.includes('_agent_'));
					if (currentAgentKeys.length > 0) {
						console.log(`[ChatStore] 🔧 立即保存：保持现有chatKeys (${chatKeys.length}个)，其中包含${currentAgentKeys.length}个智能体会话`);
					} else {
						console.log(`[ChatStore] 🔧 立即保存：保持现有chatKeys (${chatKeys.length}个)，因为当前无聊天数据需要保存`);
					}
				}
				
				// 🔧 对chatKeys数组进行去重
				const originalLength = chatKeys.length;
				chatKeys = [...new Set(chatKeys)];
				if (originalLength !== chatKeys.length) {
					console.warn(`🔧 [立即保存] chatKeys去重：${originalLength} -> ${chatKeys.length}，去除了${originalLength - chatKeys.length}个重复项`);
				}
				
				// 存储会话key列表
				localForage.setItem(key, {
					privateMsgMaxId: state.privateMsgMaxId,
					groupMsgMaxId: state.groupMsgMaxId,
					chatKeys: chatKeys
				});
			}).catch(error => {
				console.error('[ChatStore] 立即保存获取现有chatKeys失败:', error);
			});
		},
		clear(state) {
			console.log('[ChatStore] 🔧 开始清除聊天数据');
			// 修复：清除时重置为null而不是空数组，避免误用
			cacheChats = null;
			// 🔥 用户切换时完全清空会话数据（包括智能体会话）
			// 智能体会话存储在localForage中，下次loadChat会重新加载
			state.chats = [];
			state.activeChat = null;
			state.privateMsgMaxId = 0;
			state.groupMsgMaxId = 0;
		},
		
		// 🔧 新增：更新privateMsgMaxId的mutation
		updatePrivateMsgMaxId(state, msgId) {
			if (msgId && msgId > state.privateMsgMaxId) {
				console.log(`[ChatStore] 更新privateMsgMaxId: ${state.privateMsgMaxId} -> ${msgId}`);
				state.privateMsgMaxId = msgId;
				// 立即保存maxId到IndexedDB，不等待防抖
				this.commit("saveMaxIdImmediate");
			}
		},
		
		// 🔧 新增：立即保存maxId到IndexedDB
		saveMaxIdImmediate(state) {
			const userInfo = userStore.state.userInfo;
			if (!userInfo || !userInfo.id) {
				console.warn('[ChatStore] 无法保存maxId：用户信息不完整');
				return;
			}
			
			const userId = userInfo.id;
			const key = "chats-" + userId;
			
			// 立即获取当前的chatKeys
			localForage.getItem(key).then(existingData => {
				const chatKeys = existingData?.chatKeys || [];
				
				// 保存更新后的maxId
				const updatedData = {
					privateMsgMaxId: state.privateMsgMaxId,
					groupMsgMaxId: state.groupMsgMaxId,
					chatKeys: chatKeys
				};
				
				localForage.setItem(key, updatedData).then(() => {
					console.log(`[ChatStore] ✅ maxId已立即保存到IndexedDB: privateMsgMaxId=${state.privateMsgMaxId}`);
				}).catch(error => {
					console.error('[ChatStore] 保存maxId失败:', error);
				});
			});
		},

		// 终端间通信方法
		
		// 生成会话存储Key（兼容VSCode端targetId为数值的要求）
		generateChatKey(state, chatInfo) {
			if (chatInfo.isTerminalInbox) {
				// 终端收件箱：chats-{userId}-PRIVATE-{userId}_{receivingTerminal}
				const userId = userStore.state.userInfo?.id;
				return `chats-${userId}-PRIVATE-${userId}_${chatInfo.receivingTerminal}`;
			} else {
				// 普通私聊群聊：保持原有格式
				const userId = userStore.state.userInfo?.id;
				return `chats-${userId}-${chatInfo.type}-${chatInfo.targetId}`;
			}
		},
		
		// 从存储Key解析targetId（兼容VSCode端）
		parseTargetIdFromKey(state, chatKey) {
			if (chatKey.includes('_')) {
				// 终端收件箱：返回接收终端编号
				const parts = chatKey.split('_');
				return parseInt(parts[parts.length - 1]);
			} else {
				// 普通会话：返回原targetId
				const parts = chatKey.split('-');
				return parseInt(parts[parts.length - 1]);
			}
		},

		// 更新智能体会话状态
		updateAgentSessionStatus(state, { sessionId, status }) {
			console.log('[chatStore] 更新智能体会话状态:', sessionId, status);
			Vue.set(state.agentSessionStatuses, sessionId, {
				...status,
				updatedAt: Date.now()
			});
		},

		// 设置 Happy sessionId 映射
		setHappySessionMapping(state, { imChatId, happySessionId }) {
			console.log('[chatStore] 设置会话映射:', { imChatId, happySessionId });
			Vue.set(state.happySessionMappings, imChatId, happySessionId);
		},

		// 重新排序会话列表（按 lastSendTime 倒序）
		sortChats(state) {
			if (state.chats && state.chats.length > 0) {
				state.chats.sort((a, b) => {
					const timeA = a.lastSendTime || 0;
					const timeB = b.lastSendTime || 0;
					return timeB - timeA; // 倒序
				});
				console.log('[chatStore] 会话列表已重新排序');
			}
		},

		// 进入多选模式
		enterMultiSelectMode(state, chatId) {
			state.multiSelectMode.active = true;
			state.multiSelectMode.chatId = chatId;
			state.multiSelectMode.selectedMessages = [];
			console.log('[chatStore] 进入多选模式:', chatId);
		},

		// 退出多选模式
		exitMultiSelectMode(state) {
			state.multiSelectMode.active = false;
			state.multiSelectMode.selectedMessages = [];
			state.multiSelectMode.chatId = null;
			console.log('[chatStore] 退出多选模式');
		},

		// 切换消息选中状态
		toggleMessageSelection(state, messageId) {
			const index = state.multiSelectMode.selectedMessages.indexOf(messageId);
			if (index > -1) {
				state.multiSelectMode.selectedMessages.splice(index, 1);
			} else {
				state.multiSelectMode.selectedMessages.push(messageId);
			}
			console.log('[chatStore] 切换消息选中:', messageId, '当前选中数:', state.multiSelectMode.selectedMessages.length);
		},

		// 清空所有选中
		clearMessageSelection(state) {
			state.multiSelectMode.selectedMessages = [];
			console.log('[chatStore] 清空所有选中');
		},

		// 🔥 设置引用消息（单条）
		setQuotedMessage(state, { message, chatId }) {
			state.quotedMessages.active = true;
			state.quotedMessages.messages = [message];
			state.quotedMessages.chatId = chatId;
			console.log('[chatStore] 设置引用消息:', message);
		},

		// 🔥 设置引用消息（多条）
		setQuotedMessages(state, { messages, chatId }) {
			state.quotedMessages.active = true;
			state.quotedMessages.messages = messages;
			state.quotedMessages.chatId = chatId;
			console.log('[chatStore] 设置多条引用消息:', messages.length);
		},

		// 🔥 清空引用消息
		clearQuotedMessages(state) {
			state.quotedMessages.active = false;
			state.quotedMessages.messages = [];
			state.quotedMessages.chatId = null;
			console.log('[chatStore] 清空引用消息');
		},

		// 🔥 移除特定引用消息
		removeQuotedMessage(state, messageId) {
			const index = state.quotedMessages.messages.findIndex(msg =>
				(msg.id || msg.tmpId) === messageId
			);
			if (index > -1) {
				state.quotedMessages.messages.splice(index, 1);
				// 如果没有引用消息了，关闭引用状态
				if (state.quotedMessages.messages.length === 0) {
					state.quotedMessages.active = false;
					state.quotedMessages.chatId = null;
				}
				console.log('[chatStore] 移除引用消息:', messageId);
			}
		},

		// 🔥 创建智能体任务状态（关联到现有消息）
		/**
		 * 🔥 创建智能体任务状态（已废弃，初始状态嵌入AGENT_MENTION消息）
		 * 保留空实现以避免兼容性问题
		 */
		createAgentTaskStatus(state, payload) {
			console.log('[chatStore] createAgentTaskStatus已废弃，初始状态已嵌入AGENT_MENTION消息');
		},

		/**
		 * 🔥 更新智能体任务状态索引（接收WebSocket推送的AGENT_TASK_STATUS消息后更新）
		 */
		updateAgentTaskStatusIndex(state, { taskId, statusContent, chatId }) {
			// 更新索引
			Vue.set(state.agentTaskStatuses, taskId, {
				...statusContent,
				chatId: chatId,
				lastUpdate: Date.now()
			});

			// 如果有sessionId，建立映射
			if (statusContent.sessionId) {
				Vue.set(state.agentTaskSessionMappings, statusContent.sessionId, taskId);
				console.log('[chatStore] 建立 sessionId 映射:', statusContent.sessionId, '->', taskId);
			}

			console.log('[chatStore] 更新智能体任务状态索引:', taskId, statusContent.status);
		},

		// 🔥 更新智能体任务状态（已废弃，改用insertMessage + updateAgentTaskStatusIndex）
		updateAgentTaskStatus(state, { taskId, newStatus, message, extraData }) {
			// 先尝试从 map 中获取索引
			let taskInfo = state.agentTaskStatuses[taskId];
			let targetMessage = null;
			let chat = null;

			// 如果 map 中有索引，直接找消息
			if (taskInfo) {
				chat = state.chats.find(c => c.targetId === taskInfo.chatId);
				if (chat) {
					targetMessage = chat.messages.find(m => (m.id && m.id == taskInfo.messageId) || (m.tmpId && m.tmpId == taskInfo.messageId));
				}
			}

			// 如果找不到（可能是页面刷新后 map 为空），则需要遍历查找（兜底方案）
			if (!targetMessage) {
				console.warn('[chatStore] updateAgentTaskStatus: 索引失效，尝试全量搜索任务:', taskId);
				for (const c of state.chats) {
					for (const m of c.messages) {
						// 从content中查找taskId
						if (m.type === 0 && m.content) {
							try {
								const contentParsed = typeof m.content === 'string'
									? JSON.parse(m.content)
									: m.content;

								if (contentParsed && contentParsed.taskId === taskId) {
									targetMessage = m;
									chat = c;
									break;
								}
							} catch (e) {
								// 非JSON消息，忽略
							}
						}
					}
					if (targetMessage) break;
				}
			}

			if (!targetMessage) {
				console.warn('[chatStore] updateAgentTaskStatus: 找不到任务对应的消息', taskId);
				return;
			}

			// 获取当前消息content中的状态
			let currentStatus;
			try {
				const contentParsed = typeof targetMessage.content === 'string'
					? JSON.parse(targetMessage.content)
					: targetMessage.content;
				currentStatus = contentParsed;
			} catch (e) {
				console.error('[chatStore] updateAgentTaskStatus: 解析消息content失败', e);
				return;
			}

			// 更新状态逻辑
			const updatedStatus = updateTaskStatus(currentStatus, newStatus, message, extraData);

			// 🔥 更新消息content（不再使用agentTaskData）
			Vue.set(targetMessage, 'content', JSON.stringify(updatedStatus));

			// 更新 map 索引
			Vue.set(state.agentTaskStatuses, taskId, {
				messageId: targetMessage.id || targetMessage.tmpId,
				chatId: chat.targetId,
				...updatedStatus,
				lastUpdate: Date.now()
			});

			// 🔥 如果有 sessionId，建立 sessionId 到 taskId 的映射
			if (updatedStatus.sessionId) {
				Vue.set(state.agentTaskSessionMappings, updatedStatus.sessionId, taskId);
				console.log('[chatStore] 建立 sessionId 映射:', updatedStatus.sessionId, '->', taskId);
			}

			chat.stored = false;
			console.log('[chatStore] 更新智能体任务状态:', taskId, newStatus);

			// 🔥 立即触发保存，避免数据丢失
			console.log('[DEBUG-PERSIST] updateAgentTaskStatus - 触发立即保存');
			this.commit("saveToStorage");
		}
	},
	actions: {
                // 统一会话切换 - 所有会话类型使用相同的激活流程
                async switchToChat(context, chatIndex) {
                        const chats = context.getters.findChats();
                        const chat = chats[chatIndex];
                        
                        if (!chat) {
                                console.warn(`[ChatStore] 会话索引 ${chatIndex} 无效`);
                                return;
                        }
                        
                        // 统一处理：直接切换到目标会话
                        context.commit("activeChat", chatIndex);
                        console.log(`[ChatStore] ✅ 切换到会话: ${chat.showName || chat.name}，消息数: ${chat.messages?.length || 0}`);
                },
		async loadChat(context) {
			console.log('[ChatStore] 🔧 开始加载聊天数据');
			// 防重复加载检查
			if (context.state.isLoadingChat) {
				console.log('[ChatStore] 🛡️ 检测到正在加载聊天数据，跳过重复请求');
				return;
			}
			
			// 检查是否已经有数据，避免不必要的重复加载
			// 🔥 只检查普通聊天，忽略智能体会话（它们会随用户数据重新加载）
			const nonAgentChats = context.state.chats ? context.state.chats.filter(c => !c.skipGeneralStorage) : [];
			if (nonAgentChats.length > 0) {
				console.log(`[ChatStore] 🛡️ 已有${nonAgentChats.length}个普通聊天会话，跳过重复加载`);
				return;
			}
			
			// 设置加载状态
			context.commit("setLoadingChatState", true);
			
			try {
				// 等待用户信息加载完成
				const userInfo = userStore.state.userInfo;
				if (!userInfo || !userInfo.id) {
					console.warn('[ChatStore] 等待用户信息超时或失败，无法加载聊天数据');
					return; // 不抛出错误，允许应用继续运行
				}
				
				let userId = userInfo.id;
				let key = "chats-" + userId;

				// 备用方案：从localForage加载数据
				const chatsData = await localForage.getItem(key);

				
				if (!chatsData) {
					console.log('[ChatStore] 没有找到本地聊天数据');
					context.state.privateMsgMaxId = 0;
					context.state.groupMsgMaxId = 0;
					context.state.terminalMsgMaxId = 0;
					return;
				} else if (chatsData.chats) {
					// 兼容旧版本
					console.log(`[ChatStore] 从localForage加载到${chatsData.chats.length}个聊天会话`);
					context.commit("initChats", chatsData);
					context.commit("setLoadingChatState", false); // 重置加载状态
					return;
				} else if (chatsData.chatKeys) {
					const promises = [];
					chatsData.chatKeys.forEach(key => {
						promises.push(localForage.getItem(key))
					})
					const chats = await Promise.all(promises);
					
					// 处理加载的数据，区分普通会话和智能体会话
					const filteredChats = [];
					for (let i = 0; i < chatsData.chatKeys.length; i++) {
						const key = chatsData.chatKeys[i];
						const chat = chats[i];
						if (!chat) {
							continue;
						}

						// 确保 key 是字符串
						const keyStr = typeof key === 'string' ? key : String(key);

						// 检查是否是智能体会话（新格式：chatType_parentId_agent_agentId）
						if (keyStr.includes('_agent_') && !keyStr.startsWith('chats-') && !keyStr.endsWith('_meta')) {
							// 这是智能体会话的独立存储，需要转换格式
							const parts = keyStr.split('_agent_');
							if (parts.length === 2) {
								const parentPart = parts[0]; // 包含 chatType_parentId
								const agentId = parts[1] || chat.agentId;

								// 从parentPart中提取chatType和parentId
								let parentType = 'PRIVATE';  // 默认类型
								let parentId = parentPart;

								// 尝试解析新格式
								const typeParts = parentPart.split('_');
								if (typeParts.length >= 2 && (typeParts[0] === 'PRIVATE' || typeParts[0] === 'GROUP')) {
									parentType = typeParts[0];
									parentId = typeParts.slice(1).join('_'); // 处理ID中可能包含下划线的情况
								}

								// 尝试从元数据中加载头像
								let headImage = '/img/agent-default.png';
								let agentName = chat.agentName || `智能体`;

								try {
									const metaKey = `${keyStr}_meta`;
									const meta = await localForage.getItem(metaKey);
									if (meta && meta.headImage) {
										headImage = meta.headImage;
										console.log('[ChatStore] 从元数据加载头像:', keyStr, headImage);
									}
									if (meta && meta.agentName) {
										agentName = meta.agentName;
										// 🔥 修复：如果元数据中的 agentName 包含层级分隔符，只保留最后一部分
										if (agentName.includes(' › ')) {
											const fixedName = agentName.split(' › ').pop();
											console.log(`[ChatStore] 🔧 修复元数据中的多层级 agentName: "${agentName}" -> "${fixedName}"`);
											agentName = fixedName;
											// 更新元数据
											meta.agentName = fixedName;
											localForage.setItem(metaKey, meta).catch(err => {
												console.error('[ChatStore] 更新元数据失败:', err);
											});
										}
									}
								} catch (error) {
									console.warn('[ChatStore] 加载元数据失败:', error);
								}

								// 使用保存的名称信息，如果没有则尝试查找
								let parentName = chat.parentName || '会话';
								if (!chat.parentName) {
									const parentChat = filteredChats.find(c => c.targetId === parentId && c.type === parentType) ||
									                  context.state.chats.find(c => c.targetId === parentId && c.type === parentType);
									if (parentChat) {
										parentName = parentChat.showName || parentChat.name || '会话';
									}
								}

								// 创建智能体会话对象
								const agentChat = {
									type: 'AGENT',
									targetId: key,
									agentId: agentId,
									agentName: agentName,  // 保存智能体名称
									parentId: parentId,
									parentType: parentType,
									showName: `${parentName} › ${agentName}`, // 使用层级格式
								headImage: headImage,  // 使用元数据中的头像
								messages: chat.messages || [],
								lastContent: chat.messages?.length > 0 ? chat.messages[chat.messages.length - 1].content : '',
								lastSendTime: chat.startTime || Date.now(),
								unreadCount: 0,
								skipGeneralStorage: true
							};
								filteredChats.push(agentChat);
							}
						} else if (chat) {
							// 普通会话（必须有type属性）
							if (chat.type) {
								filteredChats.push(chat);
							}
						}
					}
					chatsData.chats = filteredChats;
					context.commit("initChats", chatsData);
					context.commit("setLoadingChatState", false); // 重置加载状态
					return;
				}
				
			} catch (error) {
				console.error("加载消息失败:", error);
				throw error;
			} finally {
				// 确保加载状态被重置
				context.commit("setLoadingChatState", false);

				// 🔥 新增：从服务端加载智能体会话列表（异步执行，不阻塞）
				// 只有在用户信息已加载时才调用
				const userInfo = userStore.state.userInfo;
				if (userInfo && userInfo.id) {
					context.dispatch('loadAgentChatsFromServer').catch(agentError => {
						console.error('[ChatStore] 加载智能体会话失败，但不影响主流程:', agentError);
					});
				}
			}
		},

		// 新增：迁移到VSCode存储（如果需要）
		async migrateToVSCodeIfNeeded(context) {
			try {
				const migrationStatus = vscodeStorageAdapter.getMigrationStatus();
				
				if (migrationStatus.isCompleted) {
					console.log('[ChatStore] 数据已迁移到VSCode存储');
					return migrationStatus;
				}
				
				// 安全获取用户ID - 此时用户信息应该已经加载完成
				const userInfo = userStore.state.userInfo;
				if (!userInfo || !userInfo.id) {
					console.warn('[ChatStore] 用户信息仍未加载，无法执行迁移');
					return { success: false, message: '用户信息未加载' };
				}
				
				// 获取localForage中的所有聊天数据
				const userId = userInfo.id;
				const key = "chats-" + userId;
				const chatsData = await localForage.getItem(key);
				
				console.log(`[ChatStore] 检查迁移数据，key: ${key}, 数据:`, chatsData);
				
				if (!chatsData) {
					console.log('[ChatStore] 没有localForage数据需要迁移');
					// 即使没有数据也标记迁移完成，避免重复检查
					vscodeStorageAdapter.migrationStatus.isCompleted = true;
					localStorage.setItem('vscode_migration_status', JSON.stringify(vscodeStorageAdapter.migrationStatus));
					return { success: true, message: '没有数据需要迁移' };
				}
				
				// 收集所有聊天数据
				let allChats = [];
				if (chatsData.chats) {
					allChats = chatsData.chats;
				} else if (chatsData.chatKeys) {
					console.log(`[ChatStore] 发现 chatKeys 格式数据，开始加载 ${chatsData.chatKeys.length} 个聊天`);
					const promises = chatsData.chatKeys.map(key => localForage.getItem(key));
					const chats = await Promise.all(promises);
					allChats = chats.filter(chat => chat);
				}
				
				if (allChats.length > 0) {
					console.log(`[ChatStore] 开始迁移${allChats.length}个聊天会话到VSCode存储...`);
					const result = await vscodeStorageAdapter.migrateFromLocalForage({ chats: allChats });
					console.log('[ChatStore] VSCode存储迁移结果:', result);
					return result;
				} else {
					console.log('[ChatStore] 没有有效的聊天数据需要迁移');
					// 标记迁移完成
					vscodeStorageAdapter.migrationStatus.isCompleted = true;
					localStorage.setItem('vscode_migration_status', JSON.stringify(vscodeStorageAdapter.migrationStatus));
					return { success: true, message: '没有有效数据需要迁移' };
				}
				
			} catch (error) {
				console.error('[ChatStore] VSCode存储迁移失败:', error);
				return { success: false, message: error.message };
			}
		},

		// 新增：搜索所有消息（跨平台）
		async searchAllMessages(context, { query, options = {} }) {
			try {
				if (vscodeStorageAdapter.isInVSCodeEnvironment()) {
					// 在VSCode环境中，使用FTS搜索
					const results = await vscodeStorageAdapter.searchAllMessages(query, options);
					console.log(`[ChatStore] FTS搜索"${query}"找到${results.length}条结果`);
					return results;
				} else {
					// 非VSCode环境，使用本地搜索
					return context.dispatch('searchLocalMessages', { query, options });
				}
			} catch (error) {
				console.error('[ChatStore] 搜索消息失败:', error);
				return [];
			}
		},

		// 新增：本地消息搜索（备用方案）
		searchLocalMessages(context, { query, options = {} }) {
			const lowercaseQuery = query.toLowerCase();
			const results = [];
			
			// 搜索当前已加载的聊天数据
			context.state.chats.forEach(chat => {
				if (chat.messages) {
					chat.messages.forEach(message => {
						if (message.content && message.content.toLowerCase().includes(lowercaseQuery)) {
							results.push({
								messageId: message.id || message.tmpId,
								sessionId: chat.targetId,
								sessionType: 'vue-im',
								sessionTitle: chat.showName || chat.targetId,
								content: message.content,
								sender: message.selfSend ? '我' : (message.sendNickName || '对方'),
								timestamp: message.sendTime,
								highlightedContent: message.content // 简单高亮，可以后续优化
							});
						}
					});
				}
			});
			
			return results.slice(0, options.limit || 50);
		},

		// 新增：获取FTS统计信息
		async getFTSStats(context) {
			try {
				if (vscodeStorageAdapter.isInVSCodeEnvironment()) {
					return await vscodeStorageAdapter.getFTSIndexStats();
				} else {
					// 计算本地统计
					let messageCount = 0;
					context.state.chats.forEach(chat => {
						if (chat.messages) {
							messageCount += chat.messages.length;
						}
					});
					return {
						totalMessages: messageCount,
						indexSize: messageCount * 100, // 估算
						lastUpdated: Date.now()
					};
				}
			} catch (error) {
				console.error('[ChatStore] 获取FTS统计失败:', error);
				return { totalMessages: 0, indexSize: 0, lastUpdated: 0 };
			}
		},

		// 🔧 修正：发送消息到目标终端（目标终端模式）- 支持文件消息
		async sendToTargetTerminal(context, { content, targetTerminal, type = 0, fileInfo = null }) {
			const currentTerminal = this.getters.getCurrentTerminal();
			const currentUserId = userStore.state.userInfo?.id;

			if (!currentUserId) {
				throw new Error('用户未登录');
			}

			// 🔧 验证不能发送给当前终端
			if (targetTerminal === currentTerminal) {
				throw new Error('不能发送消息给当前终端');
			}

			// 🔧 处理文件消息内容
			let messageContent = content;
			if (type === 2 && fileInfo) { // MESSAGE_TYPE.FILE = 2
				messageContent = JSON.stringify({
					name: fileInfo.name,
					size: fileInfo.size,
					url: fileInfo.url
				});
			}

			const messageData = {
				recvId: currentUserId,
				content: messageContent,
				type: type, // 支持不同消息类型：0-文本，1-图片，2-文件
				targetTerminal: targetTerminal,     // 🔧 修正：目标终端
				senderTerminal: currentTerminal     // 🔧 修正：发送端
			};

			try {
				// 检查是否有accessToken
				const accessToken = sessionStorage.getItem("accessToken");
				if (!accessToken) {
					throw new Error('用户未登录，请先登录');
				}

				// 调用后端API发送消息
				const response = await http({
					url: '/message/private/send-to-terminal',
					method: 'post',
					data: messageData,
					headers: {
						accessToken: encodeURIComponent(accessToken)
					}
				});

				// 🔧 修正：发送成功后将消息添加到本地的"目标终端会话"
				if (response && response.id) {
					// 创建/更新目标终端的会话（在本端显示为"目标终端"）
					const chatInfo = {
						type: 'PRIVATE',
						targetId: `${currentUserId}_${targetTerminal}`, // 目标终端会话ID
						senderTerminal: currentTerminal,  // 🔧 修正：记录发送端
						targetTerminal: targetTerminal,   // 🔧 修正：记录目标端
						showName: `${this.getters.getTerminalName(targetTerminal)}端`,
						headImage: this.getters.getTerminalIcon(targetTerminal),
						isTerminalChat: true  // 🔧 修正：使用新的标识
					};

					context.commit('openChat', chatInfo);

									// 🔧 将发送的消息添加到本地聊天记录
				const userInfo = userStore.state.userInfo;
				const localMessage = {
					id: response.id,
					content: messageContent, // 使用处理后的消息内容（文件消息是JSON字符串）
					type: type, // 使用传入的消息类型
					sendId: currentUserId,
					recvId: currentUserId,
					sendTime: new Date().getTime(),
					sendNickName: userInfo?.nickName || '我',
					selfSend: true, // 🔧 发送的消息，在发送端显示为自己发送的
					status: 1, // 已发送
					senderTerminal: currentTerminal,
					targetTerminal: targetTerminal
				};

					// 插入消息到会话
					context.commit('insertMessage', [localMessage, chatInfo]);
					
					// 🔧 将会话移到顶部（有新消息）
					const chatIdx = context.getters.findChatIdx(chatInfo);
					if (chatIdx > 0) {
						context.commit('moveTop', chatIdx);
					}
					
					console.log(`[ChatStore] 🔧 终端消息发送成功，发送到 ${this.getters.getTerminalName(targetTerminal)}端`);
				}

				return response;
			} catch (error) {
				console.error('发送终端间消息失败:', error);
				throw error;
			}
		},

		// 🔧 修正：加载来自指定发送端的历史消息（目标终端模式）
		async loadTerminalChatHistory(context, { senderTerminal, page = 1, size = 20 }) {
			try {
				// 检查是否有accessToken
				const accessToken = sessionStorage.getItem("accessToken");
				if (!accessToken) {
					throw new Error('用户未登录，请先登录');
				}

				const response = await http({
					url: '/message/private/terminal-chat-history',
					method: 'get',
					params: { senderTerminal, page, size },
					headers: {
						accessToken: encodeURIComponent(accessToken)
					}
				});
				return response || [];
			} catch (error) {
				console.error('加载终端聊天历史失败:', error);
				return [];
			}
		},

		// 🔥 新增：同步智能体会话到服务端
		async syncAgentChatToServer(context, chatData) {
			try {
				const response = await http({
					url: '/message/agent/chat/save',
					method: 'POST',
					data: chatData
				});
				console.log('[chatStore] 智能体会话已同步到服务端:', chatData.targetId);
			} catch (error) {
				console.error('[chatStore] 同步智能体会话失败:', error);
			}
		},

		// 🔥 新增：从服务端加载智能体会话列表
		async loadAgentChatsFromServer(context) {
			try {
				// 🔥 注意：httpRequest.js 的响应拦截器已经提取了 response.data.data
				// 所以这里的 agentChats 直接就是数组
				const agentChats = await http({
					url: '/message/agent/chat/list',
					method: 'GET'
				});

				if (agentChats && Array.isArray(agentChats)) {
					console.log(`[chatStore] 从服务端加载了 ${agentChats.length} 个智能体会话`);

					// 遍历每个智能体会话，添加到state.chats中（如果不存在）
					for (const serverChat of agentChats) {
						// 🔥 智能获取父会话名称
						let parentName = serverChat.parentName;

						// 如果后端返回的 parentName 为空或为"未知会话"，尝试从 chatStore 中查找
						if (!parentName || parentName === '未知会话') {
							const parentChat = context.state.chats.find(c =>
								c.type === serverChat.parentType &&
								String(c.targetId) === String(serverChat.parentId)
							);

							if (parentChat && parentChat.showName) {
								parentName = parentChat.showName;
								console.log(`[chatStore] 从本地会话获取父会话名称: ${parentName}`);
							} else {
								// 如果还是找不到，保持原值
								parentName = serverChat.parentName || '未知会话';
							}
						}

						// 构建会话对象
						const agentChat = {
							type: "AGENT",
							targetId: serverChat.targetId,
							agentId: serverChat.agentId,
							agentName: serverChat.agentName,
							parentId: serverChat.parentId,
							parentType: serverChat.parentType,
							parentName: parentName, // 🔥 保存 parentName 字段
							showName: `${parentName} › ${serverChat.agentName}`,
							headImage: serverChat.headImage || '/img/agent-default.png',
							messages: [],
							lastContent: serverChat.lastMessage || "",
							lastMessage: serverChat.lastMessage || "",  // 添加lastMessage字段
							lastSendTime: serverChat.lastMessageTime || serverChat.lastActiveTime || Date.now(),
							unreadCount: 0,
							stored: false,
							skipGeneralStorage: true
						};

						// 🔥 使用mutation添加会话（避免Vuex错误）
						context.commit('addAgentChatFromServer', agentChat);

						// 保存元数据到本地
						const chatMeta = {
							agentId: agentChat.agentId,
							agentName: agentChat.agentName,
							parentId: agentChat.parentId,
							parentType: agentChat.parentType,
							headImage: agentChat.headImage
						};
						await localForage.setItem(`${serverChat.targetId}_meta`, chatMeta);
					}
			}
			} catch (error) {
				console.error('[chatStore] 从服务端加载智能体会话失败:', error);
			}
		}
	},
	getters: {
		isLoading: (state) => () => {
			return state.loadingPrivateMsg || state.loadingGroupMsg
		},
		findChats: (state, getters) => () => {
			// 修复：只有在真正加载中且缓存有数据时才使用缓存
			if (cacheChats && cacheChats.length > 0 && getters.isLoading()) {
				return cacheChats;
			}
			return state.chats;
		},
		// 🔧 修正：会话比较方法（目标终端模式）
		isSameChat: (state, getters) => (chat1, chat2) => {
			// 基本类型比较
			if (chat1.type !== chat2.type) {
				return false;
			}

			// 所有相同类型的会话都通过targetId比较
			// 终端会话的targetId格式为: userId_terminalType
			// 普通会话的targetId就是对方的userId或groupId
			return chat1.targetId === chat2.targetId;
		},
		// 分离AI会话和人类IM会话
		separatedChats: (state, getters) => {
			const allChats = getters.findChats();
			return {
				aiChats: allChats.filter(chat => chat.type === 'AI'),
				humanChats: allChats.filter(chat => chat.type !== 'AI')
					.sort((a, b) => b.lastSendTime - a.lastSendTime) // 按最后消息时间倒序
			};
		},
		findChatIdx: (state, getters) => (chat) => {
			let chats = getters.findChats();
			for (let idx in chats) {
				// 使用新的会话比较逻辑
				if (getters.isSameChat(chats[idx], chat)) {
					return idx;
				}
			}
		},
		findChat: (state, getters) => (chat) => {
			let chats = getters.findChats();
			let idx = getters.findChatIdx(chat);
			return chats[idx];
		},
		findChatByFriend: (state, getters) => (fid) => {
			let chats = getters.findChats();
			return chats.find(chat => chat.type == 'PRIVATE' &&
				!chat.isTerminalInbox && chat.targetId == fid)
		},
		findChatByGroup: (state, getters) => (gid) => {
			let chats = getters.findChats();
			return chats.find(chat => chat.type == 'GROUP' &&
				chat.targetId == gid)
		},
		
		// 查找智能体会话
		findAgentChat: (state) => (parentType, parentId, agentId) => {
			return state.chats.find(c => 
				c.type === 'AGENT' && 
				c.parentType === parentType &&
				c.parentId === parentId &&
				c.agentId === agentId
			);
		},
		
		// 获取某个会话的所有智能体会话
		getChatAgents: (state) => (chat) => {
			return state.chats.filter(c => 
				c.type === 'AGENT' && 
				c.parentType === chat.type &&
				c.parentId === chat.targetId
			);
		},
		findMessage: (state) => (chat, msgInfo) => {
			if (!chat) {
				return null;
			}
			for (let idx in chat.messages) {

				// 通过id判断
				if (msgInfo.id && chat.messages[idx].id == msgInfo.id) {
					return chat.messages[idx];
				}
				// 正在发送中的消息可能没有id,只有tmpId
				if (msgInfo.tmpId && chat.messages[idx].tmpId &&
					chat.messages[idx].tmpId == msgInfo.tmpId) {
					return chat.messages[idx];
				}
			}
		},

		// 终端间通信工具方法
		getTerminalName: (state) => (terminal) => {
			const terminalNames = {
				0: '傻蛋网页',
				1: '傻蛋精灵App',
				2: '我的电脑',
				3: '我的云电脑',
				4: '傻蛋浏览器',
				5: 'MCP',
				6: '我的小龙虾'
			};
			return terminalNames[terminal] || '未知';
		},

		getTerminalIcon: (state) => (terminal) => {
			const terminalIcons = {
				0: '🌐',  // 傻蛋网页端
				1: '📱',  // 傻蛋精灵App
				2: '💻',  // 我的电脑
				3: '🖥️',   // 我的云电脑
				4: '🔌',  // 傻蛋浏览器
				5: '🤖',   // MCP端
				6: '🦞'   // 我的小龙虾
			};
			return terminalIcons[terminal] || '❓';
		},

		getCurrentTerminal: (state) => () => {
			// 根据环境判断当前终端类型
			if (typeof window !== 'undefined') {
				if (window.isVSCodeEnvironment) return 2; // VSCode
				return 0; // Web
			}
			return 1; // App或其他
		},

		// 根据 IM chatId 获取智能体会话状态
		getAgentStatus: (state) => (imChatId) => {
			const happySessionId = state.happySessionMappings[imChatId];
			if (!happySessionId) return null;
			return state.agentSessionStatuses[happySessionId];
		},

		// 获取所有活跃的智能体状态（用于轮播）
		getActiveAgentStatuses: (state) => {
			return Object.entries(state.agentSessionStatuses)
				.filter(([_, status]) =>
					status.state === 'thinking' ||
					status.state === 'permission_required'
				)
				.map(([sessionId, status]) => {
					// 反查找对应的 chat
					const imChatId = Object.entries(state.happySessionMappings)
						.find(([_, hSessionId]) => hSessionId === sessionId)?.[0];
					const chat = state.chats.find(c => c.targetId === imChatId);

					return {
						sessionId,
						imChatId,
						agentName: chat?.agentName || chat?.showName?.split(' › ').pop() || '未知智能体',
						status
					};
				});
		}
	}
}
